<template>
  <Teleport to="body">
    <div class="new-acc-modal eh-popup-overlay" ref="pageBody">
    <form id="subaccountform" class="eh-popup-panel" @submit.prevent="addNewAccountUser">
      <div v-if="allFormErrors.length" class="form-error-summary" role="alert">
        <ul>
          <li v-for="(err, idx) in allFormErrors" :key="idx">{{ err }}</li>
        </ul>
      </div>
      <div class="mb-2">
        <div class="add-user-form-header">
          <h2>{{ editMode ? "Edit User" : (isContactAccountType ? "Add Contact" : "Add User") }}</h2>
          <help-icon help-id="adduser" :title="isContactAccountType ? 'Help for Add Contact' : 'Help for Add User'" />
        </div>
        <!-- Allied Professional account type selection and fields -->
        <div v-if="userForm.accountType === 'Allied Professional'" class="row mb-2 gx-2 allied-prof-first-row">
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              id="accnttype-allied"
              class="form-control"
              v-model="userForm.accountType"
              @change="setAidValue(userForm.accountType)"
              :disabled="editAccountTypeLocked"
              required
            >
              <option value="">Select account type</option>
              <option value="Administrator">Administrator</option>
              <option value="Licensed Practical Nurse">Licensed Practical Nurse</option>
              <option value="Registered Nurse">Registered Nurse</option>
              <option value="Home Health Aid">Home Health Aid</option>
              <option value="Provider">Provider</option>
              <option value="Allied Professional">Allied Professional</option>
              <!-- GCM is a top-level account type (account_user only; no specialty table). -->
              <option value="Geriatric Care Manager">Geriatric Care Manager</option>
              <option value="Patient">Patient</option>
              <!-- Value is Contact (singular) to match CreateSubAccount / old Add Contact. -->
              <option value="Contact">Contacts</option>
            </select>
            <label for="accnttype-allied" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Type:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <!--OldCode-- <input
              type="text"
              id="AccntSpecialty"
              class="form-control"
              v-model="userForm.specialty"
              placeholder="e.g. Physical Therapy"
            /> -->
            <select id="AccntSpecialty" class="form-control" name="specialty" v-model="userForm.specialty" required>
              <option value="">-- Select specialty --</option>
            
             <!--- <optgroup label="Nursing">
                <option value="CNA">Certified Nursing Assistant (CNA)</option>
                <option value="HHA">Home Health Aide / Personal Care Aide (HHA / PCA)</option>
                <option value="CNS">Clinical Nurse Specialist (CNS)</option>
                <option value="Nurse Manager">Charge Nurse / Nurse Manager / Nursing Supervisor</option>
              </optgroup>  -->
            
              <optgroup label="Allied Health (Providers)">
                <option value="PT">Physical Therapist (PT)</option>
                <option value="OT">Occupational Therapist (OT)</option>
                <option value="SLP">Speech-Language Pathologist (SLP)</option>
                <option value="RT">Respiratory Therapist (RT)</option>
                <option value="DIETITIAN">Dietitian / Registered Dietitian Nutritionist (RDN)</option>
                <option value="BEHAVIORAL_HEALTH">Clinical Social Worker / Counselor (LCSW)</option>
                <option value="PSYCHOLOGIST"> Psychologist (LCP)</option>
                <option value="RAD_TECH">Radiology Technologist</option>
                <option value="SONOGRAPHER">Sonographer / Imaging Tech</option>
                <option value="LAB_TECH">Medical Technologist / Lab Technologist</option>
                <option value="ORTHOTIST_PROSTHETIST">Orthotist / Prosthetist</option>
                <option value="ATHLETIC_TRAINER">Athletic Trainer (AT)</option>
                <option value="REHAB_AIDE">Speech/Language or Rehab Aide</option>
                <option value="OR_SUPPORT">Perfusionist / Anesthesia Tech / Surgical Technologist</option>
              <!---  Consolidating All Account Types under Allied professional attempt -->
                <option value="CNA">Certified Nursing Assistant (CNA)</option>
                <option value="HHA">Home Health Aide / Personal Care Aide (HHA / PCA)</option>
                <option value="CNS">Clinical Nurse Specialist (CNS)</option>
                <option value="Nurse Manager">Charge Nurse / Nurse Manager / Nursing Supervisor</option>
              </optgroup>
            
            <!----  <optgroup label="Physician (true Providers)">
                <option value="PHYSICIAN_MD">Physician (MD)</option>
                <option value="PA">Physician Assistant</option>
                <option value="PHYSICIAN_DO">Physician (DO)</option>
                <option value="PHARMACIST">Pharmacist</option>
                <option value="CHIROPRACTOR">Chiropractor</option>
                <option value="PODIATRIST">Podiatrist</option>
                <option value="DENTAL">Dentist / Dental Hygienist</option>
                <option value="DENTAL_HYGIENIST"> Dental Hygienist</option>
                <option value="NP">Nurse Practitioner (NP)</option>
                <option value="SURGEON">Surgeon</option>
              </optgroup> -->
            </select>
            <label for="AccntSpecialty" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Specialty:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="accountexternid"
              id="Accntexternid"
              class="form-control"
              disabled
              v-model="userForm.externid"
            />
            <label for="AccntId" class="profile_label">ID #:</label>
          </div>
        </div>
        <!-- Geriatric Care Manager: own first-row form (no specialty / professional license). -->
        <div
          v-else-if="userForm.accountType === 'Geriatric Care Manager'"
          class="row mb-2 gx-2 gcm-first-row"
        >
          <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              id="accnttype-gcm"
              class="form-control"
              v-model="userForm.accountType"
              @change="setAidValue(userForm.accountType)"
              :disabled="editAccountTypeLocked"
              required
            >
              <option value="">Select account type</option>
              <option value="Administrator">Administrator</option>
              <option value="Licensed Practical Nurse">Licensed Practical Nurse</option>
              <option value="Registered Nurse">Registered Nurse</option>
              <option value="Home Health Aid">Home Health Aid</option>
              <option value="Provider">Provider</option>
              <option value="Allied Professional">Allied Professional</option>
              <option value="Geriatric Care Manager">Geriatric Care Manager</option>
              <option value="Patient">Patient</option>
              <option value="Contact">Contacts</option>
            </select>
            <label for="accnttype-gcm" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Type:</label>
          </div>
          <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="accountexternid-gcm"
              id="AccntexternidGcm"
              class="form-control"
              disabled
              v-model="userForm.externid"
            />
            <label for="AccntexternidGcm" class="profile_label">ID #:</label>
          </div>
        </div>
        <!-- Contacts: Account Type + Patient + Contact Type on one line; ID kept smallest. -->
        <div
          v-else-if="needsContactPatientAndType"
          class="row mb-2 gx-2 contact-patient-first-row"
        >
          <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              id="accnttype-contact"
              class="form-control"
              v-model="userForm.accountType"
              @change="setAidValue(userForm.accountType)"
              :disabled="editAccountTypeLocked || lockAccountTypeToContact"
              required
            >
              <option value="">Select account type</option>
              <option value="Administrator">Administrator</option>
              <option value="Licensed Practical Nurse">Licensed Practical Nurse</option>
              <option value="Registered Nurse">Registered Nurse</option>
              <option value="Home Health Aid">Home Health Aid</option>
              <option value="Provider">Provider</option>
              <option value="Allied Professional">Allied Professional</option>
              <option value="Geriatric Care Manager">Geriatric Care Manager</option>
              <option value="Patient">Patient</option>
              <option value="Contact">Contacts</option>
            </select>
            <label for="accnttype-contact" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Type:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              id="contact-patient-select"
              class="form-control"
              v-model="selectedPatientId"
              required
            >
              <option value="" disabled>{{ loadingPatients ? "Loading patients..." : "-- Select Patient --" }}</option>
              <option
                v-for="p in patientList"
                :key="p.patient_id"
                :value="p.patient_id"
              >
                {{ formatPatientName(p) }}
              </option>
            </select>
            <label for="contact-patient-select" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Patient:</label>
          </div>
          <!-- Same relation list as the Contacts page (allData.relationDescriptions). -->
          <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              id="contact-relation-type"
              class="form-control"
              v-model.number="selectedRelationTypeId"
              required
            >
              <option :value="0" disabled>-- Select Contact Type --</option>
              <option
                v-for="relation in contactRelationOptions"
                :key="relation.id"
                :value="relation.id"
              >
                {{ relation.value }}
              </option>
            </select>
            <label for="contact-relation-type" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Contact Type:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0 contact-id-col">
            <input
              type="text"
              name="accountexternid-contact"
              id="AccntexternidContact"
              class="form-control"
              disabled
              v-model="userForm.externid"
            />
            <label for="AccntexternidContact" class="profile_label">ID #:</label>
          </div>
        </div>
        <!-- Default first row (Account Type + ID). -->
        <div v-else class="row mb-2 gx-2">
          <!-- Contact account type is implicit when lockAccountTypeToContact; hide the repeated field. -->
          <div
            v-if="!lockAccountTypeToContact"
            class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <template v-if="lockAccountTypeToProvider">
              <input
                id="accnttype-locked"
                type="text"
                class="form-control"
                value="Provider"
                disabled
                readonly
              />
              <label for="accnttype-locked" class="profile_label">Account Type:</label>
            </template>
            <template v-else-if="lockToNurseRoleTypes">
              <select
                id="accnttype-nurse"
                class="form-control"
                v-model="userForm.accountType"
                @change="setAidValue(userForm.accountType)"
                required
              >
                <option value="">Select nurse type</option>
                <option value="Registered Nurse">Registered Nurse</option>
                <option value="Licensed Practical Nurse">Licensed Practical Nurse</option>
              </select>
              <label for="accnttype-nurse" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Type:</label>
            </template>
            <template v-else>
              <select
                id="accnttype"
                class="form-control"
                v-model="userForm.accountType"
                @change="setAidValue(userForm.accountType)"
                :disabled="editAccountTypeLocked"
                required
              >
                <option value="">Select account type</option>
                <option value="Administrator">Administrator</option>
                <option value="Licensed Practical Nurse">
                  Licensed Practical Nurse
                </option>
                <option value="Registered Nurse">Registered Nurse</option>
                <option value="Home Health Aid">Home Health Aid</option>
                <option value="Provider">Provider</option>
                <option value="Allied Professional">Allied Professional</option>
                <!-- GCM: account_user only; no specialty / license fields below. -->
                <option value="Geriatric Care Manager">Geriatric Care Manager</option>
                <option value="Patient">Patient</option>
                <!-- Same create path as former Administration Add Contact (account type Contact). -->
                <option value="Contact">Contacts</option>
              </select>
              <label for="AccntRole" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Type:</label>
            </template>
          </div>
          <!--Attemp to Add Provider Type form fields to set provider Typek (provider Table )-->
          <div v-if="userForm.accountType=='Provider'" class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <select id="provtype" class="form-control" v-model="userForm.providerType" @change="checkProviderType()" required>
              <option value="">---Select Provider Type---</option>
                <option value="Physician">Physicians</option>
                <option value="Doctors of Osteopathic Medicin">Doctors of Osteopathic Medicine</option>
                <option value="Physician Assistant">Physician Assistant</option>
                <option value="CHIROPRACTOR">Chiropractor</option>
                <option value="PODIATRIST">Podiatrist</option>
                <option value="DENTAL">Dentist / Dental Hygienist</option>
                <option value="DENTAL_HYGIENIST"> Dental Hygienist</option>
                <option value="Nurse Practitioner">Nurse Practitioner (NP)</option>
                <option value="SURGEON">Surgeon</option>
            </select>
            <label for="provtype" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Provider Type:</label>
          </div>
          <div v-if="userForm.accountType=='Home Health Aid'" class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <select 
              id="hascert"
              class="form-control"
              v-model="userForm.hascertificate"
            >
              <option value="">Aid Have Certificate?</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <label for="hascrert" class="profile_label">Has Certificate?</label>
          </div>
          <div v-if="userForm.hascertificate=='Yes'" class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <input type="text"
              id="certificatenum"
              class="form-control"
              v-model="userForm.certificateValue"
              @keyup="validateRoleIdentifier"
              placeholder="License/Certificate Information"
            />
            <label for="certificatenum" class="profile_label">Certificate Number</label>
          </div>
          <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="accountexternid"
              id="Accntexternid"
              class="form-control"
              disabled
              v-model="userForm.externid"
            />
            <label for="AccntId" class="profile_label">ID #:</label>
          </div>
        </div>
        <div v-if="showsNpiLookup" class="row mb-2 gx-2">
          <div class="col-12">
            <!-- Administrators often have no NPI: keep lookup optional and collapsed. -->
            <button
              v-if="isAdministratorAccountType && !usedButtonClicked"
              type="button"
              class="npi-lookup-collapse-toggle"
              :aria-expanded="npiLookupOpen ? 'true' : 'false'"
              @click="npiLookupOpen = !npiLookupOpen"
            >
              <span class="npi-lookup-arrow" :class="{ 'is-open': npiLookupOpen }" aria-hidden="true">›</span>
              <span>
                Optional NPI registry lookup
                <span class="npi-lookup-optional-note">— only if this administrator has an NPI</span>
              </span>
            </button>
            <!-- Hide card after "Use"; for Admin also stay collapsed until expanded. -->
            <div
              v-if="!usedButtonClicked"
              v-show="!isAdministratorAccountType || npiLookupOpen"
              class="npi-lookup-card p-2 border rounded bg-light"
              :class="{ 'mt-2': isAdministratorAccountType }"
            >
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="fw-bold">NPI lookup</div>
                <div class="btn-group btn-group-sm" role="group" aria-label="NPI lookup mode">
                  <button
                    type="button"
                    class="btn"
                    :class="npiLookupMode === 'name' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="npiLookupMode = 'name'"
                  >
                    Name
                  </button>
                  <button
                    type="button"
                    class="btn"
                    :class="npiLookupMode === 'number' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="npiLookupMode = 'number'"
                  >
                    NPI #
                  </button>
                </div>
              </div>

              <div v-if="npiLookupMode === 'number'" class="row gx-2 align-items-end">
                <div class="col-md-6 col-12">
                  <label class="profile_label mb-1" for="npiLookupNumber">NPI number</label>
                  <input
                    id="npiLookupNumber"
                    class="form-control"
                    type="text"
                    inputmode="numeric"
                    placeholder="10-digit NPI"
                    v-model="npiLookupForm.npi"
                    @keypress="pressToLookupNpi"
                  />
                </div>
                <div class="col-md-6 col-12 mt-2 mt-md-0">
                  <button type="button" class="btn btn-success w-100" @click="handleNpiLookup" :disabled="npiLookupLoading">
                    {{ npiLookupLoading ? 'Searching...' : 'Search NPI registry' }}
                  </button>
                </div>
              </div>

              <div v-else class="row gx-2 align-items-end">
                <div class="col-md-4 col-12">
                  <label class="profile_label mb-1" for="npiLookupFirst">First name</label>
                  <input
                    id="npiLookupFirst"
                    class="form-control"
                    type="text"
                    placeholder="Optional"
                    v-model="npiLookupForm.first"
                    @keypress="pressToLookupNpi"
                  />
                </div>
                <div class="col-md-4 col-12 mt-2 mt-md-0">
                  <label class="profile_label mb-1" for="npiLookupLast">Last name</label>
                  <input
                    id="npiLookupLast"
                    class="form-control"
                    type="text"
                    placeholder="Required"
                    v-model="npiLookupForm.last"
                    @keypress="pressToLookupNpi"
                  />
                </div>
                <div class="col-md-4 col-12 mt-2 mt-md-0">
                  <button type="button" class="btn btn-success w-100" @click="handleNpiLookup" :disabled="npiLookupLoading">
                    {{ npiLookupLoading ? 'Searching...' : 'Search' }}
                  </button>
                </div>
              </div>

              <div v-if="npiLookupError" class="text-danger small mt-2">
                {{ npiLookupError }}
              </div>

              <div v-if="npiLookupResults.length > 0" class="mt-2">
                <div class="small text-muted mb-1">
                  Showing {{ npiLookupPaginateData.length }} of {{ npiLookupResults.length }} result(s)
                </div>
                <ul class="npi-results list-unstyled mb-0">
                  <li
                    v-for="(npi, idx) in npiLookupPaginateData"
                    :key="`${npi.npinumber || npi.id}-${idx}`"
                    class="npi-result-item p-2 mb-2 border rounded bg-white"
                  >
                    <div class="d-flex justify-content-between align-items-start gap-2">
                      <div class="flex-grow-1">
                        <div class="fw-bold">{{ formatProviderDisplayName(npi) }}</div>
                        <div class="small text-muted">{{ formatProviderAddress(npi) }}</div>
                        <div class="small">
                          <span v-if="npi.npinumber"><b>NPI:</b> {{ npi.npinumber }}</span>
                          <span v-if="npi.phone" class="ms-2"><b>Phone:</b> {{ npi.phone }}</span>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary btn-sm" @click="selectNpiFromLookup(npi)">
                        Use
                      </button>
                    </div>
                  </li>
                </ul>

                <div v-if="npiLookupPageCount > 1" class="d-flex justify-content-between align-items-center">
                  <button type="button" class="btn btn-link px-0" :disabled="npiLookupPageNumber === 0" @click="npiLookupPrevPage">
                    Previous
                  </button>
                  <div class="small text-muted">
                    Page {{ npiLookupPageNumber + 1 }} / {{ npiLookupPageCount }}
                  </div>
                  <button
                    type="button"
                    class="btn btn-link px-0"
                    :disabled="npiLookupPageNumber >= npiLookupPageCount - 1"
                    @click="npiLookupNextPage"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Only relevant when creating a brand-new Patient account - editing an
             existing patient's info shouldn't re-trigger the verification email,
             and Contact accounts do not have patient verification. -->
        <div v-if="userForm.accountType === 'Patient' && !editMode" class="row mb-2 gx-2">
          <div class="col-12">
            <div class="form-check">
              <input
                id="requirePatientVerification"
                type="checkbox"
                class="form-check-input"
                v-model="userForm.requirePatientVerification"
              />
              <label class="form-check-label" for="requirePatientVerification">
                Require patient verification
              </label>
            </div>
          </div>
        </div>
        <div class="row mb-2 gx-2">
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="firstname"
              id="AccntFname"
              required
              class="form-control"
              placeholder="Required"
              @keyup="validateName('first')"
              v-model="userForm.first"
            />
            <label for="AccntFname" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>First Name:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="lastname"
              id="AccntLname"
              class="form-control"
              placeholder="Required"
              required
              @keyup="validateName('last')"
              v-model="userForm.last"
            />
            <label for="AccntLname" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Last Name:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="accountUname"
              id="AccntpUsername"
              class="form-control"
              placeholder="Required"
              required
              @keyup="validateUsername"
              v-model="userForm.login"
              :disabled="editMode"
            />
            <label for="AccntUsername" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Username:</label>
          </div>
        </div>
        <div class="row mb-2 gx-2">
          <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="email"
              name="accountEmail"
              id="AccntEmail"
              required
              placeholder="Required"
              class="form-control"
              @keyup="validateEmail"
              v-model="userForm.email"
              :disabled="editMode"
            />
            <label for="AccntEmail" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Account Email:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              v-model="userForm.primaryPhoneType"
              class="col-12 form-select"
              
            >
              <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                {{ phone.type }}
              </option>
            </select>
            <label class="profile_label">Phone type</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              id="regphone"
              class="form-control"
              v-model="userForm.primaryPhone"
              placeholder="Required"
            />
            <label for="mblphone" class="profile_label">Phone Number</label>
          </div>
        </div>
        <div class="row mb-2 gx-2">
          <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="personalAddress"
              id="AccntAddress"
              class="form-control"
              placeholder="Required"
              v-model="userForm.addr"
            />
            <label for="AccntAddress" class="profile_label">Address:</label>
          </div>
          <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              v-model="userForm.city"
              type="text"
              name="personalcity"
              id="AccntCity"
              class="form-control"
              placeholder="Required"
            />
            <label for="AccntCity" class="profile_label">City:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              v-model="userForm.state"
              name="personalstate"
              id="AccntState"
              class="form-select"
            >
              <option value="">Select a state</option>
              <option
                v-for="(state, index) in states"
                :key="index"
                :value="state.abbr"
              >
                {{ state.abbr }}
              </option>
            </select>
            <label for="AccntState" class="profile_label">State:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              v-model="userForm.zip"
              type="text"
              name="personalzip"
              id="AccntZip"
              class="form-control"
              placeholder="Required"
            />
            <label for="AccntZip" class="profile_label">Zip:</label>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 npi-container">
          <div class="col-sm-12 col-md-12 col-lg-12 npi-license">
            <label for="Npiproflicense">NPI</label>
            <input
              v-model="userForm.npi"
              type="text"
              name="Npipersonalicense"
              id="AccntNpilicense"
            />
          </div>
        </div>
        <div class="row mb-2 gx-2">
          <div
            v-if="showsDobField"
            class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <input
              class="form-control"
              v-model="userForm.dob"
              type="date"
              id="dob"
              name="dob"
            />
            <label for="AccntDob" class="profile_label">DOB:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <select
              v-model="userForm.gender"
              name="accountGender"
              id="AccntGender"
              required
              class="form-select"
            >
              <option value="">Please select</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
            <label for="AccntGender" class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Gender:</label>
          </div>
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <select id="AccntPref" class="form-select" v-model="userForm.pref">
              <option value="Email" selected="selected">Email</option>
              <option value="SMS">SMS</option>
              <option value="Phone">Phone</option>
              <option value="All">SMS, Phone & Email</option>
            </select>
            <label for="AccntPref" class="profile_label"
              >Communication Preference:</label
            >
          </div>
          <div
            v-if="isNurseUser"
            class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <input
              class="form-control"
              type="text"
              name="personalicense"
              id="Accntproflicense"
              @keyup="validateRoleIdentifier"
              v-model="userForm.licenseNum"
            />
            <label for="Accntproflicense" class="profile_label"
              >Professional License:</label
            >
          </div>
          <div
            v-if="!editKeepCurrentType && (userForm.accountType === 'Provider' || userForm.accountType === 'Administrator')"
            class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <input
              class="form-control"
              type="text"
              name="providernpi"
              id="AccntProviderNpi"
              @keyup="validateNpi"
              v-model="userForm.npi"
            />
            <label for="AccntProviderNpi" class="profile_label">NPI:</label>
          </div>
          <div
            v-if="userForm.accountType === 'Allied Professional'"
            class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <input
              class="form-control"
              type="text"
              name="personalicense"
              id="Accntproflicense"
              @keyup="validateRoleIdentifier"
              v-model="userForm.licenseNum"
            />
            <label for="Accntproflicense" class="profile_label">Professional License:</label>
          </div>
          <div
            v-if="isNurseUser"
            class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0"
          >
            <select
              v-model="userForm.licenseSt"
              name="licensestate"
              id="LicenseState"
              class="form-select"
              @change="validateRoleIdentifier"
            >
              <option value="">Select a state</option>
              <option
                v-for="(state, index) in states"
                :key="index"
                :value="state.abbr"
              >
                {{ state.abbr }}
              </option>
            </select>
            <label for="AccntState" class="profile_label">License State:</label>
          </div>
          <div v-if="userForm.accountType=='Home Health Aid'" class="col-md-5 col-12 form-group form-floating mb-2 mb-log-0">
            <span v-if="fileprocessing" class="formprocess">....processing</span>
            <input class="form-control" v-on:change="sendFile()" type="file" name="files" id="insurancePdf" value=""/>
            <label for="files" class="profile_label">Upload Insurance:</label>
            <span class="file_link" v-if="keyonFileUrl(nwform.insurance_file_uid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(nwform.insurance_file_uid)">View PDF</a></span>
            <span class="file_link" v-else-if="keyonFileUrl(userForm.currentInsuranceFileUid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(userForm.currentInsuranceFileUid)">Currently on file: View PDF</a></span>

          </div>
          <div
            v-if="isNurseUser"
            class="col-md-6 col-12 form-group form-floating mb-2 mb-log-0"
          >
            <input
              class="form-control"
              type="file"
              name="licenseFile"
              id="licensePdf"
              v-on:change="sendFile2"
            />
            <label for="files" class="profile_label">Upload License PDF:</label>
            <span class="file_link" v-if="keyonFileUrl(nwform.license_file_uid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(nwform.license_file_uid)">View PDF</a></span>
            <span class="file_link" v-else-if="keyonFileUrl(userForm.currentLicenseFileUid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(userForm.currentLicenseFileUid)">Currently on file: View PDF</a></span>
          </div>
          <div
            v-if="isNurseUser"
            class="col-md-6 col-12 form-group form-floating mb-2 mb-log-0"
          >
            <input
              class="form-control"
              type="file"
              name="insuranceFile"
              id="insurancePdf"
              v-on:change="sendFile"
            />
            <label for="files" class="profile_label">Upload Insurance PDF:</label>
            <span class="file_link" v-if="keyonFileUrl(nwform.insurance_file_uid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(nwform.insurance_file_uid)">View PDF</a></span>
            <span class="file_link" v-else-if="keyonFileUrl(userForm.currentInsuranceFileUid)"><a target="_blank" rel="noopener noreferrer" :href="keyonFileUrl(userForm.currentInsuranceFileUid)">Currently on file: View PDF</a></span>
          </div>
        </div>
        <div v-if="isNurseUser" class="row mb-2 gx-2">
          <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              type="text"
              name="insuranceCompany"
              id="insuranceCompany"
              class="form-control"
              v-model="userForm.insuranceCompany"
            />
            <label for="insuranceCompany" class="profile_label"
              >Insurance Company:</label
            >
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              class="form-control"
              type="date"
              id="insuranceStart"
              name="insuranceStart"
              v-model="userForm.insuranceStart"
            />
            <label for="insuranceStart" class="profile_label">Insurance Start:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              class="form-control"
              type="date"
              id="insuranceEnd"
              name="insuranceEnd"
              v-model="userForm.insuranceEnd"
            />
            <label for="insuranceEnd" class="profile_label">Insurance End:</label>
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              class="form-control"
              type="number"
              id="perIncidentAmnt"
              name="perIncidentAmnt"
              v-model="userForm.perIncidentAmnt"
            />
            <label for="perIncidentAmnt" class="profile_label"
              >Per Incident Limit:</label
            >
          </div>
          <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
            <input
              class="form-control"
              type="number"
              id="annualAggAmnt"
              name="annualAggAmnt"
              v-model="userForm.annualAggAmnt"
            />
            <label for="annualAggAmnt" class="profile_label">Annual Limit:</label>
          </div>
        </div>
        <!-- Contact creation uses fixed Contacts/Patients group wiring; hide group UI. -->
        <div
          v-if="!isContactAccountType && (!editMode || !editHasRoleRecord)"
          class="row mb-2 gx-2"
        >
          <div class="col-md-6 col-12 form-group mb-2 mb-lg-0">
            <label class="profile_label d-block mb-1">Primary group from account type</label>
            <div class="form-control bg-light">
              {{ selectedAccountPrimaryGroupLabel }}
            </div>
          </div>
          <div class="col-md-6 col-12 form-group mb-2 mb-lg-0">
            <label for="extraTopGroups" class="profile_label d-block mb-1">Also add to top-level groups</label>
            <select
              id="extraTopGroups"
              class="form-select"
              multiple
              v-model="userForm.additionalTopLevelGroupIds"
              :disabled="loadingTopLevelGroups"
            >
              <option
                v-for="g in availableAdditionalTopLevelGroups"
                :key="g.id"
                :value="String(g.id)"
              >
                {{ g.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Caregiver create flow: queue patients into pending_group_assignments until verify.
             Same collapse chrome as optional Admin NPI lookup above. -->
        <div v-if="showsCaregiverPatientAssignment" class="row mb-2 gx-2">
          <div class="col-12">
            <button
              type="button"
              class="npi-lookup-collapse-toggle"
              :aria-expanded="assignmentPanelOpen ? 'true' : 'false'"
              @click="toggleAssignmentPanel"
            >
              <span
                class="npi-lookup-arrow"
                :class="{ 'is-open': assignmentPanelOpen }"
                aria-hidden="true"
              >›</span>
              <span>
                Optional patient assignment
                <span class="npi-lookup-optional-note"
                  >— {{ assignedPatientsPreview.length }} selected; pending until they verify</span
                >
              </span>
            </button>
            <div
              v-show="assignmentPanelOpen"
              class="npi-lookup-card caregiver-assign-card p-2 border rounded bg-light mt-2"
            >
              <p class="caregiver-assign-hint">
                Choose which patients this caregiver will see after they verify their account.
                Assignments stay pending until email verification completes.
              </p>
              <div class="caregiver-assign-search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
                <input
                  type="search"
                  class="form-control"
                  v-model="assignmentPatientSearch"
                  placeholder="Search patients by name…"
                  aria-label="Search patients to assign"
                />
              </div>
              <div class="caregiver-assign-panels">
                <div class="caregiver-assign-panel">
                  <div class="caregiver-assign-panel-label">Available</div>
                  <ul class="caregiver-assign-list" role="listbox" aria-label="Available patients">
                    <li
                      v-for="p in filteredAvailableAssignmentPatients"
                      :key="'avail-' + p.patient_id"
                      class="caregiver-assign-item"
                    >
                      <div class="caregiver-assign-item-meta">
                        <span class="caregiver-assign-name">{{ formatPatientName(p) }}</span>
                        <span v-if="p.date_of_birth || p.dob" class="caregiver-assign-dob"
                          >DOB {{ p.date_of_birth || p.dob }}</span
                        >
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="assignPatientLocally(p.patient_id)"
                      >
                        Assign
                      </button>
                    </li>
                    <li v-if="filteredAvailableAssignmentPatients.length === 0" class="caregiver-assign-empty">
                      {{
                        loadingPatients
                          ? "Loading patients..."
                          : !patientList.length
                            ? "No patients found."
                            : assignmentPatientSearch.trim()
                              ? "No matching patients."
                              : "All patients are assigned."
                      }}
                    </li>
                  </ul>
                </div>
                <div class="caregiver-assign-panel caregiver-assign-panel--assigned">
                  <div class="caregiver-assign-panel-label">Assigned</div>
                  <ul class="caregiver-assign-list" role="listbox" aria-label="Assigned patients">
                    <li
                      v-for="p in assignedPatientsPreview"
                      :key="'asgn-' + p.patient_id"
                      class="caregiver-assign-item"
                    >
                      <div class="caregiver-assign-item-meta">
                        <span class="caregiver-assign-name">{{ formatPatientName(p) }}</span>
                        <span v-if="p.date_of_birth || p.dob" class="caregiver-assign-dob"
                          >DOB {{ p.date_of_birth || p.dob }}</span
                        >
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="unassignPatientLocally(p.patient_id)"
                      >
                        Remove
                      </button>
                    </li>
                    <li v-if="assignedPatientsPreview.length === 0" class="caregiver-assign-empty">
                      No patients assigned yet.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="editMode && canManageCredentials" class="account-access-section">
          <hr class="account-access-divider" />
          <button
            type="button"
            class="account-access-toggle"
            @click="toggleCredentialsPanel"
            :aria-expanded="credentialsPanelOpen"
          >
            <span class="glyphicon" :class="credentialsPanelOpen ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'"></span>
            Manage Account Access
          </button>
          <Transition name="slide-panel">
            <div v-if="credentialsPanelOpen" class="account-access-panel">
              <p class="account-access-hint">
                Change this person's username, account email, or password. These changes take effect immediately and are separate from the profile fields above.
              </p>
              <p v-if="postgresLoginExists === false" class="account-access-warning">
                This person has no login record yet - this panel can only update an existing login, not create one.
              </p>
              <p v-else-if="postgresSyncNote" class="account-access-warning">
                {{ postgresSyncNote }}
              </p>

              <div class="row mb-2 gx-2">
                <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                  <input
                    type="text"
                    class="form-control"
                    id="credUsername"
                    v-model="credentialsForm.username"
                    @change="validateCredentialsUsername"
                  />
                  <label for="credUsername" class="profile_label">Username</label>
                  <form-error v-if="credentialsErrors.username.length" :errors="credentialsErrors.username" />
                </div>
                <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                  <input
                    type="email"
                    class="form-control"
                    id="credEmail"
                    v-model="credentialsForm.email"
                    @change="validateCredentialsEmail"
                  />
                  <label for="credEmail" class="profile_label">Account Email</label>
                  <form-error v-if="credentialsErrors.email.length" :errors="credentialsErrors.email" />
                </div>
              </div>

              <div class="account-access-password-mode form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="credInviteToggle"
                  v-model="credentialsInviteMode"
                />
                <label class="form-check-label" for="credInviteToggle">
                  Send a password reset email instead of setting one directly
                </label>
              </div>

              <div v-if="!credentialsInviteMode" class="row mb-2 gx-2">
                <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                  <input
                    :type="showCredPassword ? 'text' : 'password'"
                    class="form-control"
                    id="credPassword"
                    v-model="credentialsForm.newPassword"
                    @change="validateCredentialsPassword"
                  />
                  <label for="credPassword" class="profile_label">New Password</label>
                  <form-error v-if="credentialsErrors.newPassword.length" :errors="credentialsErrors.newPassword" />
                </div>
                <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                  <input
                    :type="showCredPassword ? 'text' : 'password'"
                    class="form-control"
                    id="credPassword2"
                    v-model="credentialsForm.newPassword2"
                    @change="validateCredentialsPassword"
                  />
                  <label for="credPassword2" class="profile_label">Confirm Password</label>
                  <form-error v-if="credentialsErrors.newPassword2.length" :errors="credentialsErrors.newPassword2" />
                </div>
                <div class="col-12">
                  <button type="button" class="show-password-toggle" @click="showCredPassword = !showCredPassword">
                    {{ showCredPassword ? "Hide" : "Show" }} password
                  </button>
                </div>
              </div>
              <div v-else class="account-access-invite-preview">
                Reset email will be sent to: <strong>{{ credentialsForm.email || "no email on file" }}</strong>
              </div>

              <div class="account-access-actions">
                <input
                  type="button"
                  class="btn btn-primary"
                  :value="credentialsSaving ? 'Saving…' : 'Save Account Access'"
                  :disabled="credentialsSaving || !credentialsFormIsValid"
                  @click="saveAccountAccess"
                />
                <span
                  v-if="credentialsResultMessage"
                  class="account-access-result"
                  :class="credentialsResultIsError ? 'text-danger' : 'text-success'"
                  >{{ credentialsResultMessage }}</span
                >
              </div>
            </div>
          </Transition>
        </div>
        <div class="row mb-2 gx-2">
          <div class="accountform-btn">
            <input
              type="submit"
              class="btn btn-primary"
              :value="editMode ? 'Save Changes' : (isContactAccountType ? 'Add Contact' : 'Submit New User')"
              id="sbmtuserbtn"
              :disabled="!formIsValid || fileprocessing"
              :title="fileprocessing ? 'Wait for the file upload to finish' : (!formIsValid ? 'Fill out all required fields to continue' : '')"
            />
            <input
              type="button"
              class="btn btn-secondary"
              value="Close"
              id="addnursebtn"
              @click="handleClose"
            />
            <span v-if="editMode && lastSavedAt" class="last-saved-indicator">
              &#10003; Saved at {{ lastSavedAt.toLocaleTimeString() }} - values below reflect what's now on file
            </span>
          </div>
        </div>
      </div>
    </form>
    </div>
  </Teleport>
</template>

<script>
import $ from "jquery";
import { CURR_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { refusalMessage } from "@/api/refusals";
import { isFileUid, keyonFileUrl } from "@/utils/fileUrl";
import {
  appendCredentialSlots,
  buildUploadNurseFileForm,
  changedUidKeys,
  promoteInsuranceUid,
  sentCredentialUids,
  unclaimedUploads,
} from "@/utils/credentialUploadForm";
import { discardUnclaimedCredentialUpload } from "@/api/keyonFiles";
import FormError from "@/components/public-layouts/register/FormError";
import HelpIcon from "@/components/help/HelpIcon.vue";
import { h } from "vue";
import us from "us";
import VALIDATION_ERRORS from "@/data/validationErrors";
import { searchNpiViaRegistry } from "@/api/pdfApi";
import { usePrivilegesStore } from "@/stores/privileges";
import { PRIVILEGES } from "@/constants/privileges";
import { resolveKeyonPrivilegeIdentity } from "@/api/privilegesApi";
import { getPasswordPolicyErrors } from "@/utils/passwordPolicy";
import { savePatientContact } from "@/api/patientContactsApi";

export default {
  name: "AddUserForm",
  components: {
    "form-error": FormError,
    HelpIcon,
  },
  props: {
    lockAccountTypeToProvider: {
      type: Boolean,
      default: false,
    },
    /** When true, account type is fixed to Contact (e.g. register from patient contacts page). */
    lockAccountTypeToContact: {
      type: Boolean,
      default: false,
    },
    /** When true, a patient + contact-type selector is required (Add User → Contacts, or legacy requirePatientSelection). */
    requirePatientSelection: {
      type: Boolean,
      default: false,
    },
    /** Optional contact record used to pre-fill the form when registering a contact account. */
    prefillContact: {
      type: Object,
      default: null,
    },
    /** When true, only Registered Nurse / Licensed Practical Nurse (e.g. Patient Nurses page). */
    lockToNurseRoleTypes: {
      type: Boolean,
      default: false,
    },
    /** When true, this form edits an existing person found via Edit Users search
     * instead of creating a brand-new account. */
    editMode: {
      type: Boolean,
      default: false,
    },
    /** Resolved record from SearchAccountForEdit: { uniqueID, accountnumber, firstname,
     * lastname, email, accountType, foundIn: [...], account_user, providers, nurses, patients } */
    editRecord: {
      type: Object,
      default: null,
    },
    /** Accounts/account_user-only match, admin chose "Edit Account Details"
     * rather than "Add a New Account Type" - keeps the current account type
     * locked and skips the dual-role email on save. */
    editKeepCurrentType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      states: us.states,
      userForm: {
        isLoggedIn: false,
        noValidation: false,
        admin: true,
        id: null,
        accountType: "",
        specialty: "",
        providerType: "", //Type of Provider that sets Label Provider in account_user/provider table (provider type | professionType)
        npi: "",
        externid: "",
        externid2: "",
        first: "",
        last: "",
        login: "",
        password: "PACMNY_Reg1!",
        password2: "PACMNY_Reg1!",
        enrollmentId: null,
        // Placeholder until register() allows a null DOB. Empty string fails
        // Yii required validation ("Date of Birth cannot be blank").
        dob: "1970-01-01",
        email: "",
        gender: null,
        addr: "",
        city: "",
        state: "",
        zip: "",
        hascertificate: "",
        certificateValue: "",
        primaryPhoneType: null,
        primaryPhone: null,
        ssn: "",
        pref: "Email",
        licenseNum: "",
        licenseSt: "",
        insuranceCompany: "",
        insuranceStart: "",
        insuranceEnd: "",
        perIncidentAmnt: "",
        annualAggAmnt: "",
        // Edit mode only - the currently-on-file license/insurance file uids,
        // shown as "currently on file" links since a native file input can
        // never be pre-populated with an existing file.
        currentLicenseFileUid: "",
        currentInsuranceFileUid: "",
        isHomeHealthAid: "",
        actiontaken: "",
        additionalTopLevelGroupIds: [],
        requirePatientVerification: true,
      },
      userFormErrors: {},
      // license_file_uid / insurance_file_uid land here from an immediate upload.
      nwform: {},
      // Immediate credential uploads still on their way. A count, not a flag:
      // a nurse's licence and insurance can upload at the same time.
      credentialUploadsInFlight: 0,
      isHomeHealthAid: "",
      isaccntTypeProvider: false, //Boolean to determine provier type addtion to the Add User Form
      // Patient / relation selectors when account type is Contacts (Add User flow)
      selectedPatientId: "",
      // Relation / contact type from allData.relationDescriptions (same list as Contacts page)
      selectedRelationTypeId: 0,
      patientList: [],
      loadingPatients: false,
      orgTopLevelGroups: [],
      loadingTopLevelGroups: false,
      npiLookupMode: "name", // 'name' | 'number', default lookup by name
      npiLookupOpen: false, // Admin-only: collapsed until they expand optional NPI lookup
      npiLookupForm: {
        first: "",
        last: "",
        specialty: "",
        npi: "",
      },
      usedButtonClicked:false, //helps to show or hide NPI card section 
      npiLookupResults: [],
      npiLookupLoading: false,
      npiLookupError: "",
      npiLookupPageNumber: 0,
      npiLookupPageSize: 3,
      npiValidationSeq: 0,
      roleIdValidationSeq: 0,
      // Local mutable copy of the editRecord prop. Re-fetched and reassigned
      // after a successful save so the form can refresh with current values in
      // place, without requiring the admin to close/re-search/reload.
      workingEditRecord: null,
      lastSavedAt: null,
      // Account Access panel (manage_account_credentials privilege only) -
      // separate save action from the profile fields above since it hits a
      // different backend endpoint (Postgres LA_user + MySQL mirror) with its
      // own success/failure surface.
      credentialsPanelOpen: false,
      credentialsInviteMode: false,
      // null = not checked yet, true/false = Postgres LA_user row confirmed
      // present/absent for this person (see loadAuthoritativeLoginIdentity).
      postgresLoginExists: null,
      postgresSyncNote: "",
      showCredPassword: false,
      credentialsSaving: false,
      credentialsResultMessage: "",
      credentialsResultIsError: false,
      credentialsForm: {
        username: "",
        email: "",
        newPassword: "",
        newPassword2: "",
      },
      credentialsErrors: {
        username: [],
        email: [],
        newPassword: [],
        newPassword2: [],
      },
      // Caregiver patient assignment (create modal). Persisted as pending_group_assignments
      // on CreateSubAccount; promoted to live proto_group_members on verify → Active.
      assignmentPanelOpen: false,
      assignmentPatientSearch: "",
      assignedPatientIds: [],
    };
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    canManageCredentials() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.MANAGE_ACCOUNT_CREDENTIALS);
    },
    /** Gates the "Save Account Access" button. Any of username/email/password
     * being a real, validated change is enough - all three are optional and
     * independent (the backend only touches whichever ones you actually filled in). */
    credentialsFormIsValid() {
      const c = this.credentialsForm;
      const hasUsernameChange = !!c.username && c.username !== (this.workingEditRecord?.username || "");
      const hasEmailChange = !!c.email && c.email !== (this.workingEditRecord?.email || "");
      const hasPasswordChange = this.credentialsInviteMode
        ? !!c.email
        : !!c.newPassword && c.newPassword === c.newPassword2;
      if (!hasUsernameChange && !hasEmailChange && !hasPasswordChange) return false;
      const noErrors = (arr) => !arr || arr.length === 0;
      return (
        noErrors(this.credentialsErrors.username) &&
        noErrors(this.credentialsErrors.email) &&
        (this.credentialsInviteMode || (noErrors(this.credentialsErrors.newPassword) && noErrors(this.credentialsErrors.newPassword2)))
      );
    },
    /** Flattens userFormErrors (an object of field -> error[] arrays) into one
     * list for the top-of-form error summary, so every field's errors funnel
     * through a single place instead of inline messages under each input. */
    allFormErrors() {
      const out = [];
      for (const key in this.userFormErrors) {
        const fieldErrors = this.userFormErrors[key];
        if (Array.isArray(fieldErrors)) {
          for (const msg of fieldErrors) {
            if (msg) out.push(msg);
          }
        }
      }
      return out;
    },
    /** Gates the submit button. Mirrors the template's `required` attributes
     * directly off userForm's reactive fields rather than the native form's
     * checkValidity() - reading DOM validity via a form-level input/change
     * listener risked interfering with in-progress native <select> interactions
     * (a toggled disabled attribute can cancel an open dropdown mid-selection
     * in some browsers), so this stays purely in Vue's own reactivity. */
    formIsValid() {
      const f = this.userForm;
      if (!f.accountType) return false;
      if (!f.first || !f.last) return false;
      if (!f.login) return false;
      if (!f.email) return false;
      if (!f.gender) return false;
      if (f.accountType === "Allied Professional" && !f.specialty) return false;
      if (f.accountType === "Provider" && !f.providerType) return false;
      // Contacts from Add User (or locked+require): patient and contact type are required
      if (this.needsContactPatientAndType && !this.selectedPatientId) {
        return false;
      }
      if (this.needsContactPatientAndType && !this.selectedRelationTypeId) {
        return false;
      }
      return true;
    },
    phoneTypes() {
      return this.allData?.phoneTypes || [];
    },
    /** Same contact-type / relation list shown on the Contacts page. */
    contactRelationOptions() {
      return this.allData?.relationDescriptions || [];
    },
    selectedContactRelationName() {
      const id = Number(this.selectedRelationTypeId) || 0;
      if (!id) return "";
      const match = this.contactRelationOptions.find((r) => Number(r.id) === id);
      return match?.value || "";
    },
    isNurseUser() {
      return (
        this.userForm.accountType === "Registered Nurse" ||
        this.userForm.accountType === "Licensed Practical Nurse"
      );
    },
    /** Account type Contact / Contacts (backend accepts both spellings). */
    isContactAccountType() {
      const t = String(this.userForm.accountType || "").trim().toLowerCase();
      return t === "contact" || t === "contacts";
    },
    /**
     * Staff roles that own a patient panel (nurses, providers, allied, HHA, GCM).
     * Shown only while adding a user — selections save to pending_group_assignments.
     */
    showsCaregiverPatientAssignment() {
      if (this.editMode) return false;
      const t = String(this.userForm.accountType || "").trim().toLowerCase();
      return [
        "licensed practical nurse",
        "registered nurse",
        "home health aid",
        "provider",
        "allied professional",
        "geriatric care manager",
      ].includes(t);
    },
    assignedPatientsPreview() {
      const selected = new Set((this.assignedPatientIds || []).map(String));
      return (this.patientList || []).filter((p) => selected.has(String(p.patient_id)));
    },
    filteredAvailableAssignmentPatients() {
      const selected = new Set((this.assignedPatientIds || []).map(String));
      const q = String(this.assignmentPatientSearch || "").trim().toLowerCase();
      return (this.patientList || []).filter((p) => {
        if (selected.has(String(p.patient_id))) return false;
        if (!q) return true;
        return this.formatPatientName(p).toLowerCase().includes(q);
      });
    },
    /**
     * Show patient + contact-type dropdowns when creating a Contacts account from Add User,
     * or when requirePatientSelection is set with a locked contact type.
     * Register-from-Contacts-page (lock only) keeps using the active patient instead.
     */
    needsContactPatientAndType() {
      return this.isContactAccountType && (!this.lockAccountTypeToContact || this.requirePatientSelection);
    },
    showsPatientFormFields() {
      return (
        this.userForm.accountType === "Patient" ||
        this.isContactAccountType
      );
    },
    /** DOB only actually persists for records backed by the `patients` or
     * `nurses` tables (account_user/providers have no dob column at all).
     * In edit mode, editFoundIn already tells us exactly which table this
     * specific record lives in - trust that over the displayed account type
     * label, since an Allied Professional can map to `nurses` depending on
     * specialty. Falls back to showsPatientFormFields for the create flow,
     * where there's no existing record to check yet. */
    showsDobField() {
      if (this.editMode) {
        return this.editFoundIn.includes("nurses") || this.editFoundIn.includes("patients");
      }
      return this.showsPatientFormFields;
    },
    selectedAccountPrimaryGroup() {
      const t = String(this.userForm.accountType || "").trim().toLowerCase();
      if (t === "patient") return "Patients";
      if (t === "contact" || t === "contacts") return "Contacts";
      if (t === "provider") return "Providers";
      if (t === "allied professional") return "Allied Professionals";
      // Primary org group assigned on create for GCM accounts.
      if (t === "geriatric care manager") return "Geriatric Care Managers";
      if (t === "administrator") return "Administrators";
      if (["nurse", "registered nurse", "licensed practical nurse"].includes(t)) return "Nurses";
      if (["home health aid", "home health aids", "home health aide", "home health aides"].includes(t)) {
        return "Home Health Aids";
      }
      return "";
    },
    selectedAccountPrimaryGroupLabel() {
      return this.selectedAccountPrimaryGroup || "-";
    },
    availableAdditionalTopLevelGroups() {
      const selectedPrimary = String(this.selectedAccountPrimaryGroup || "").trim().toLowerCase();
      return (this.orgTopLevelGroups || []).filter((g) => {
        const n = String(g?.name || "")
          .trim()
          .toLowerCase();
        return !selectedPrimary || n !== selectedPrimary;
      });
    },
    fileprocessing() {
      return this.credentialUploadsInFlight > 0;
    },
    // Calculate total pages for NPI lookup results
    npiLookupPageCount() {
      const l = Array.isArray(this.npiLookupResults) ? this.npiLookupResults.length : 0;
      return Math.max(1, Math.ceil(l / this.npiLookupPageSize));
    },
    // Get active page of NPI lookup results
    npiLookupPaginateData() {
      const start = this.npiLookupPageNumber * this.npiLookupPageSize;
      const end = start + this.npiLookupPageSize;
      return (this.npiLookupResults || []).slice(start, end);
    },
    /** Provider / Admin / NPI-bearing Allied roles get the optional registry lookup. */
    showsNpiLookup() {
      if (this.editKeepCurrentType) return false;
      const t = this.userForm.accountType;
      if (t === "Provider" || t === "Administrator") return true;
      if (t !== "Allied Professional") return false;
      const s = this.userForm.specialty;
      return (
        s === "PODIATRIST" ||
        s === "DENTAL" ||
        s === "Dental Hygienist" ||
        s === "CHIROPRACTOR" ||
        s === "DENTAL_HYGIENIST" ||
        s === "NP" ||
        s === "PHARMACIST"
      );
    },
    isAdministratorAccountType() {
      return this.userForm.accountType === "Administrator";
    },
    /** Which identity tables SearchAccountForEdit found this person in. */
    editFoundIn() {
      return (this.workingEditRecord && this.workingEditRecord.foundIn) || [];
    },
    /** True once this person already has a Provider/Nurse/Patient profile - the
     * account type can't change on this path (a3: update in place). False means
     * they were found only in accounts/account_user - the admin is picking a
     * brand-new role for them (a2: promote). */
    editHasRoleRecord() {
      return (
        this.editFoundIn.includes("providers") ||
        this.editFoundIn.includes("nurses") ||
        this.editFoundIn.includes("patients")
      );
    },
    editAccountTypeLocked() {
      return this.editMode && (this.editHasRoleRecord || this.editKeepCurrentType);
    },
  },
  created() {
    // Licence and insurance files uploaded on pick and not saved yet
    // (utils/credentialUploadForm.js). Not reactive: nothing renders from it.
    // Every save that can carry them is wrapped in beginSave()/endSave().
    this.unclaimedCredentialUploads = unclaimedUploads(discardUnclaimedCredentialUpload);
  },
  async mounted() {
    await this.initForm();
  },
  beforeUnmount() {
    // Closed, cancelled or left without saving: release the files this form
    // uploaded and never saved, instead of leaving them to the sweep's 7 days.
    // keyon keeps any that a save did claim. While a save is still in flight
    // the tracker waits for it - a release could beat it and fail it - and
    // releases what it did not claim when it ends.
    this.unclaimedCredentialUploads.releaseAll();
  },
  methods: {
    keyonFileUrl,
    async initForm() {
      this.userForm.externid = Math.floor(Math.random() * 899999999) + 100000000;
      // Only meaningful when creating a brand-new Patient account - editing
      // shouldn't ever re-trigger the verification email, regardless of path,
      // and Contact accounts do not require patient verification.
      this.userForm.requirePatientVerification = !this.editMode;
      this.userForm.additionalTopLevelGroupIds = [];
      for (let key in this.userForm) {
        this.userFormErrors[key] = [];
      }
      await this.loadOrgTopLevelGroupsForUserForm();
      if (this.editMode) {
        this.workingEditRecord = this.editRecord ? { ...this.editRecord } : null;
        this.applyEditPrefill();
        if (this.canManageCredentials) {
          await this.loadAuthoritativeLoginIdentity();
        }
      } else if (this.lockAccountTypeToProvider) {
        this.userForm.accountType = "Provider";
        this.setAidValue("Provider");
      } else if (this.lockAccountTypeToContact) {
        this.userForm.accountType = "Contact";
        this.setAidValue("Contact");
        this.applyContactPrefill();
        // Contact account type does not have or require patient verification
        this.userForm.requirePatientVerification = false;
        // When patient selection is required (e.g. Add Contact from Administration), fetch all patients
        if (this.requirePatientSelection) {
          await this.loadAllPatientsForContact();
        }
      } else if (this.lockToNurseRoleTypes) {
        this.userForm.accountType = "";
      }
    },
    /** Prefill userForm from the record SearchAccountForEdit resolved. Email,
     * externid (account/unique ID) and personal ID are intentionally left as the
     * only fields the template disables - everything else here is editable. */
    /** patients.gender has a mix of legacy text ("Male"/"Female") and the
     * numeric codes ("1"/"2") the Gender <select> options actually use - map
     * text to the matching code so the dropdown shows the saved value instead
     * of appearing blank/reset. */
    normalizeGenderCode(value) {
      const v = String(value || "").trim().toLowerCase();
      if (v === "1" || v === "male" || v === "m") return "1";
      if (v === "2" || v === "female" || v === "f") return "2";
      return value || null;
    },
    applyEditPrefill() {
      const r = this.workingEditRecord;
      if (!r) return;
      this.userForm.accountType = r.accountType || "";
      this.userForm.externid = r.uniqueID || this.userForm.externid;
      this.userForm.email = r.email || "";
      this.userForm.login = r.username || "";
      this.userForm.first = r.firstname || "";
      this.userForm.last = r.lastname || "";
      this.credentialsForm.username = r.username || "";
      this.credentialsForm.email = r.email || "";

      const au = r.account_user || {};
      this.userForm.addr = au.address || "";
      this.userForm.city = au.city || "";
      this.userForm.state = au.state || "";
      this.userForm.zip = au.zip || "";
      this.userForm.primaryPhone = au.user_phone || "";
      this.userForm.pref = au.communication_preference || "Email";
      this.userForm.licenseNum = au.proffesionalLicense || "";
      this.userForm.insuranceCompany = au.insuranceCompany || "";
      this.userForm.insuranceStart = au.insuranceStart || "";
      this.userForm.insuranceEnd = au.insuranceEnd || "";
      this.userForm.perIncidentAmnt = au.perIncLimit || "";
      this.userForm.annualAggAmnt = au.annLimit || "";

      if (r.providers) {
        const p = r.providers;
        this.userForm.npi = p.npinumber || "";
        this.userForm.providerType = p.providerType || "";
        this.userForm.addr = p.addr1 || this.userForm.addr;
        this.userForm.city = p.city || this.userForm.city;
        this.userForm.state = p.state || this.userForm.state;
        this.userForm.zip = p.postalcode || this.userForm.zip;
        this.userForm.primaryPhone = p.tel || this.userForm.primaryPhone;
      }
      if (r.nurses) {
        const n = r.nurses;
        this.userForm.licenseNum = n.licensenum || n.certificatenumber || this.userForm.licenseNum;
        this.userForm.licenseSt = n.state || "";
        this.userForm.hascertificate = n.certificatenumber ? "Yes" : "";
        this.userForm.certificateValue = n.certificatenumber || "";
        this.userForm.addr = n.addr1 || this.userForm.addr;
        this.userForm.city = n.city || this.userForm.city;
        this.userForm.state = n.state || this.userForm.state;
        this.userForm.zip = n.zip || this.userForm.zip;
        this.userForm.primaryPhone = n.primaryphone || this.userForm.primaryPhone;
        this.userForm.dob = n.dob || this.userForm.dob;
        // The nurses table is what UpdateNurse actually writes back to -
        // prefill from its own perIncidentAmnt/annualAggAmnt, not
        // account_user's separate perIncLimit/annLimit columns, or saving
        // would silently overwrite the real value with the unrelated one.
        this.userForm.perIncidentAmnt = n.perIncidentAmnt || this.userForm.perIncidentAmnt;
        this.userForm.annualAggAmnt = n.annualAggAmnt || this.userForm.annualAggAmnt;
        // Same reasoning - nurses has its own insuranceCompany/insuranceStart/
        // insuranceEnd columns that UpdateNurse writes to, separate from
        // account_user's copy prefilled above.
        this.userForm.insuranceCompany = n.insuranceCompany || this.userForm.insuranceCompany;
        this.userForm.insuranceStart = n.insuranceStart || this.userForm.insuranceStart;
        this.userForm.insuranceEnd = n.insuranceEnd || this.userForm.insuranceEnd;
        this.userForm.currentLicenseFileUid = n.license_file_uid || "";
        this.userForm.currentInsuranceFileUid = n.insurance_file_uid || "";
      }
      if (r.patients) {
        const p = r.patients;
        this.userForm.dob = p.date_of_birth || this.userForm.dob;
        this.userForm.gender = this.normalizeGenderCode(p.gender) || this.userForm.gender;
        this.userForm.addr = p.address || this.userForm.addr;
        this.userForm.city = p.city || this.userForm.city;
        this.userForm.state = p.state || this.userForm.state;
        this.userForm.zip = p.zip || this.userForm.zip;
        this.userForm.primaryPhone = p.contact_number || this.userForm.primaryPhone;
      }
    },
    /** Postgres LA_user is the primary login source and can drift from
     * MySQL account_user's copy of username/email (a prior correction that
     * only landed on one side, etc). Re-seeds the Account Access panel with
     * what Postgres actually has on file, so the admin edits the real
     * current values instead of a possibly-stale MySQL snapshot. */
    async loadAuthoritativeLoginIdentity() {
      const identity = resolveKeyonPrivilegeIdentity(this.allData);
      const targetUniqueID = this.workingEditRecord?.uniqueID || this.userForm.externid;
      if (!identity.accountnumber || !identity.unique_ID || !targetUniqueID) return;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "GetAccountLoginIdentity",
              accountnumber: identity.accountnumber,
              actorId: identity.unique_ID,
              targetUniqueID,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        const data = res.data || {};
        if (data.status !== "200") {
          this.postgresLoginExists = null;
          return;
        }
        this.postgresLoginExists = !!data.exists;
        if (!data.exists) return;
        const pgUsername = data.username || "";
        const pgEmail = data.email || "";
        if ((pgUsername && pgUsername !== this.credentialsForm.username) || (pgEmail && pgEmail !== this.credentialsForm.email)) {
          this.postgresSyncNote = "The email on file didn't match what we have on file. The email that's been submitted is now the email of record.";
        }
        this.credentialsForm.username = pgUsername;
        this.credentialsForm.email = pgEmail;
        if (this.workingEditRecord) {
          this.workingEditRecord.username = pgUsername;
          this.workingEditRecord.email = pgEmail;
        }
      } catch (err) {
        this.postgresLoginExists = null;
      }
    },
    checkProviderType(){
      console.log("Provider Type Console Log - Check The Value");
      console.log(this.userForm.providerType);
    },
    // Trigger NPI lookup when Enter key is pressed
    pressToLookupNpi(event) {
      if (event && event.keyCode === 13) {
        this.handleNpiLookup();
      }
    },
    // Clear NPI lookup results
    clearNpiLookupResults() {
      this.npiLookupResults = [];
      this.npiLookupError = "";
      this.npiLookupPageNumber = 0;
    },
    // Perform NPI lookup
    handleNpiLookup() {
      this.npiLookupError = "";
      this.npiLookupPageNumber = 0;
      const form = {
        first: (this.npiLookupForm.first || "").trim(),
        last: (this.npiLookupForm.last || "").trim(),
        specialty: (this.npiLookupForm.specialty || "").trim(),
        npi: (this.npiLookupForm.npi || "").trim(),
      };

      // Keep behavior consistent with existing registry search: last OR npi required.
      if (!form.last && !form.npi) {
        this.clearNpiLookupResults();
        this.npiLookupError =
          this.npiLookupMode === "number"
            ? "Please enter an NPI number."
            : "Please enter at least a last name (or switch to NPI # search).";
        return;
      }

      this.npiLookupLoading = true;
      searchNpiViaRegistry(form)
        .then((rows) => {
          this.npiLookupResults = Array.isArray(rows) ? rows : [];
          if (this.npiLookupResults.length === 0) {
            this.npiLookupError = "No providers found. Try refining your search.";
          }
        })
        .catch((err) => {
          console.error(err);
          this.npiLookupResults = [];
          this.npiLookupError =
            typeof err === "string" ? err : err?.message || "Unable to search NPI registry right now.";
        })
        .finally(() => {
          this.npiLookupLoading = false;
        });
    },
    // Selecting NPI result from results list should fill in relevant form fields
    selectNpiFromLookup(npi) {
      const selectedNpi = String(npi?.npinumber || npi?.id || "").trim();
      if (!selectedNpi) return;

      this.userForm.npi = selectedNpi;
      // Some backend paths historically used licenseNum as NPI for providers/admins.
      this.userForm.licenseNum = selectedNpi;

      // Populate first/last name fields too.
      if (npi?.first_name) this.userForm.first = this.titleCase(String(npi.first_name));
      if (npi?.last_name) this.userForm.last = this.titleCase(String(npi.last_name));

      // Always update address/phone on selection (switching providers should update fields).
      this.userForm.addr = npi?.address_first_line ? this.titleCase(String(npi.address_first_line)) : "";
      this.userForm.city = npi?.address_city ? this.titleCase(String(npi.address_city)) : "";
      this.userForm.state = npi?.address_state ? String(npi.address_state).trim() : "";
      this.userForm.primaryPhone = npi?.phone ? String(npi.phone).trim() : "";

      this.npiLookupForm.npi = selectedNpi;

      // A registry-picked NPI can still already be registered — run the check.
      this.validateNpi();
      //Addling this line (KW) to update the boolean to hide the NPI card section since the NPI result of choice has been selected at this point
      this.usedButtonClicked =true;
    },
    // Fixing returned lookup results to have proper capitalization
    titleCase(value) {
      const s = String(value || "").trim();
      if (!s) return "";
      // Normalize whitespace, then title-case each word.
      return s
        .replace(/\s+/g, " ")
        .toLowerCase()
        .replace(/\b([a-z])/g, (m) => m.toUpperCase());
    },
    // Formatting the display name for the NPI lookup results
    formatProviderDisplayName(npi) {
      const parts = [npi?.first_name, npi?.middle_name, npi?.last_name]
        .map((p) => String(p || "").trim())
        .filter(Boolean)
        .map((p) => this.titleCase(p));
      return parts.join(" ");
    },
    // Formatting the address for the NPI lookup results
    formatProviderAddress(npi) {
      const line1 = npi?.address_first_line ? this.titleCase(String(npi.address_first_line)) : "";
      const city = npi?.address_city ? this.titleCase(String(npi.address_city)) : "";
      const state = npi?.address_state ? String(npi.address_state).trim() : "";
      return [line1, [city, state].filter(Boolean).join(", ")].filter(Boolean).join(", ");
    },
    npiLookupNextPage() {
      this.npiLookupPageNumber++;
    },
    npiLookupPrevPage() {
      this.npiLookupPageNumber--;
    },
    applyContactPrefill() {
      const c = this.prefillContact;
      if (!c) return;
      if (c.firstName) this.userForm.first = c.firstName;
      if (c.lastName) this.userForm.last = c.lastName;
      if (c.email) this.userForm.email = c.email;
      if (c.primaryPhone) this.userForm.primaryPhone = c.primaryPhone;
      if (c.primaryPhoneType) this.userForm.primaryPhoneType = c.primaryPhoneType;
      if (c.address1) this.userForm.addr = c.address1;
      if (c.city) this.userForm.city = c.city;
      if (c.zip) this.userForm.zip = c.zip;
      if (c.dob) this.userForm.dob = c.dob;
      if (c.state) {
        const stateList = this.allData?.states || [];
        const stateId = Number(c.state);
        const match = stateList.find((s) => s.id === stateId);
        if (match?.abbr) this.userForm.state = match.abbr;
      }
    },
    /**
     * Fetch all patients for the organization to populate the patient selector
     * dropdown when adding a contact from Administration.
     * Uses GetPatientsForHomeGrid with owner_unique_ID: null to load the org-level
     * patient roster.
     */
    async loadAllPatientsForContact() {
      this.loadingPatients = true;
      try {
        const accountnumber = this.allData?.patient?.externId2;
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Groups: {
              API_Meth: "GetPatientsForHomeGrid",
              accountnumber,
              owner_unique_ID: null,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.patientList = rows
          .map((r) => {
            const patientId = String(r.patient_id || r.mid || r.unique_ID || "").trim();
            const firstName = (r.first_name || r.firstname || "").trim();
            const lastName = (r.lastname || "").trim();
            const displayName = `${firstName} ${lastName}`.trim() || "Unknown Patient";
            return {
              ...r,
              patient_id: patientId,
              first_name: firstName,
              lastname: lastName,
              displayName,
            };
          })
          .filter((p) => !!p.patient_id);
      } catch (err) {
        console.error("Failed to load patient list for contact creation:", err);
        this.patientList = [];
      } finally {
        this.loadingPatients = false;
      }
    },
    /**
     * Format a patient record for the selector dropdown display.
     * Displays patient's name only, strictly avoiding showing their ID.
     */
    formatPatientName(patient) {
      if (!patient) return "";
      if (patient.displayName) return patient.displayName;
      const first = (patient.first_name || patient.firstname || "").trim();
      const last = (patient.lastname || "").trim();
      return `${first} ${last}`.trim() || "Unknown Patient";
    },
    handleClose() {
      this.$emit("close");
    },
    setAidValue(accntType) {
      if (accntType == "Home Health Aid") {
        this.isHomeHealthAid = accntType;
      } else {
        this.isHomeHealthAid = "";
      }
      if(accntType =="Provider")
      {
        //automatically setting this back to false show the NPI Bar will show up should the user try and change provider type after they've selected a NPI results prev (KW)
        this.usedButtonClicked = false;
        this.isaccntTypeProvider = true;
        //set isHomeHealthAid  to empty
        this.isHomeHealthAid ="";
        //set Allied Health speciality to empty
        this.userForm.specialty ="";
      }
      // Clear specialty field for non-Allied Professional accounts
      if (accntType !== "Allied Professional") {
        this.userForm.specialty = "";
      }
      // Drop any stale NPI uniqueness error when leaving an NPI-bearing role so a
      // hidden error can't silently block submit.
      if (accntType !== "Provider" && accntType !== "Administrator") {
        this.usedButtonClicked = false; //If user happen to be an administrator that Could an NPI
        this.userFormErrors.npi = [];
      }
      // Reset optional admin NPI panel when account type changes.
      this.npiLookupOpen = false;
      this.clearNpiLookupResults();
      // Same for the per-role license/certificate uniqueness errors — clear them
      // on any account-type change so a hidden error can't silently block submit.
      this.userFormErrors.licenseNum = [];
      this.userFormErrors.certificateValue = [];
      // Clear the identifier VALUES too. Otherwise a stale licenseNum from a prior
      // role wins the `licenseNum || npi` fallback at submit and gets sent to keyon
      // as the NPI (and vice-versa), silently corrupting the registered identifier.
      this.userForm.licenseNum = "";
      this.userForm.npi = "";
      this.userForm.certificateValue = "";
      // "Require patient verification" is only applicable to brand-new Patient accounts, not Contacts or staff
      if (accntType !== "Patient") {
        this.userForm.requirePatientVerification = false;
      } else if (!this.editMode) {
        this.userForm.requirePatientVerification = true;
      }
      // Contacts from Add User: load org patients; clear leftover top-level group picks
      // (group UI is hidden for contacts, same as former Add Contact).
      if (accntType === "Contact" || accntType === "Contacts") {
        this.userForm.additionalTopLevelGroupIds = [];
        if (!this.lockAccountTypeToContact || this.requirePatientSelection) {
          this.loadAllPatientsForContact();
        }
      } else {
        this.selectedPatientId = "";
        this.selectedRelationTypeId = 0;
      }
      // Reset caregiver assignment preview whenever account type changes.
      this.assignmentPanelOpen = false;
      this.assignmentPatientSearch = "";
      this.assignedPatientIds = [];
      // Same org roster used by Contacts — reuse it for caregiver assignment UI.
      if (this.showsCaregiverPatientAssignment) {
        this.loadAllPatientsForContact();
      }
      const primary = String(this.selectedAccountPrimaryGroup || "")
        .trim()
        .toLowerCase();
      if (primary) {
        const validIds = new Set(this.availableAdditionalTopLevelGroups.map((g) => String(g.id)));
        this.userForm.additionalTopLevelGroupIds = (this.userForm.additionalTopLevelGroupIds || []).filter((id) =>
          validIds.has(String(id))
        );
      }
    },
    // Add to pending_group_assignments for caregiver create flow.
    assignPatientLocally(patientId) {
      const id = String(patientId || "").trim();
      if (!id) return;
      if (this.assignedPatientIds.includes(id)) return;
      this.assignedPatientIds = [...this.assignedPatientIds, id];
    },
    // Remove from pending_group_assignments for caregiver create flow.
    unassignPatientLocally(patientId) {
      const id = String(patientId || "").trim();
      this.assignedPatientIds = (this.assignedPatientIds || []).filter((x) => String(x) !== id);
    },
    toggleAssignmentPanel() {
      this.assignmentPanelOpen = !this.assignmentPanelOpen;
      if (this.assignmentPanelOpen && this.showsCaregiverPatientAssignment) {
        this.loadAllPatientsForContact();
      }
    },
    async loadOrgTopLevelGroupsForUserForm() {
      this.loadingTopLevelGroups = true;
      try {
        const content = {
          Groups: {
            API_Meth: "GetGroupsByAccount",
            accountnumber: this.allData.patient.externId2,
          },
        };
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });
        const groups = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.orgTopLevelGroups = groups
          .filter((g) => {
            const noParent =
              g.parent_group_id === null ||
              g.parent_group_id === "" ||
              Number(g.parent_group_id) === 0;
            const noOwner = g.owner_unique_ID == null || String(g.owner_unique_ID).trim() === "";
            return noParent && noOwner;
          })
          .map((g) => ({ id: Number(g.id), name: String(g.name || "").trim() }))
          .sort((a, b) => a.name.localeCompare(b.name));
      } catch (e) {
        console.error("Failed to load top-level groups for account form:", e);
        this.orgTopLevelGroups = [];
      } finally {
        this.loadingTopLevelGroups = false;
      }
    },
    // Immediate credential upload during registration or edit: keyon stores the
    // file against the person being created or edited (userForm.externid holds
    // their own unique_ID in both modes) and answers with its uid, which the
    // form sends in place of the file.
    async uploadCredentialSlot(input, pdftype, uidKey) {
      let formdata;
      try {
        formdata = buildUploadNurseFileForm({
          file: input?.files?.[0],
          pdftype,
          accountnumber: this.allData.patient.externId2,
          subaccnt: this.userForm.externid,
        });
      } catch (e) {
        alert("File upload wasn't successful, please try again");
        return;
      }
      this.credentialUploadsInFlight += 1;
      try {
        // No headers option: axios must not coerce FormData, and keyon's
        // cross-site guard accepts only JSON or multipart.
        const res = await axios.post(CURR_API + "/tswebhook.php", formdata);
        this.credentialUploadsInFlight -= 1;
        if (isFileUid(res.data?.file_uid)) {
          this.nwform[uidKey] = res.data.file_uid;
          // Held until the form is saved; the file it replaces in this slot,
          // if this form uploaded one, is released now.
          this.unclaimedCredentialUploads.hold(uidKey, res.data.file_uid);
          alert("File upload Successful");
        } else {
          alert(refusalMessage(res.data) || "File upload wasn't successful, please try again");
        }
      } catch (err) {
        this.credentialUploadsInFlight -= 1;
        console.log(err);
        // 413 for a file over 20 MB, 503 when uploads are unavailable: both
        // arrive as rejected requests, in the server's words.
        alert(refusalMessage(err?.response?.data) || "System error, Please try again or contact the system Administrator for assistance.");
      }
    },
    async sendFile() {
      await this.uploadCredentialSlot(document.getElementById("insurancePdf"), "insurance", "insurance_file_uid");
    },
    async sendFile2() {
      await this.uploadCredentialSlot(document.getElementById("licensePdf"), "license", "license_file_uid");
    },
    /** True, and says so, while an immediate upload has not answered: its uid
     * is not on the form yet, so a save now would go without it. */
    credentialUploadStillRunning() {
      if (!this.fileprocessing) return false;
      this.$swal({ type: "warning", title: "Please wait", text: "A file is still uploading. Save once it has finished." });
      return true;
    },
    async addNewAccountUser() {
      if (this.editMode) {
        return this.submitEditAccount();
      }
      if (this.credentialUploadStillRunning()) {
        return;
      }
      let isaid = "";
      let hvcertificate = "";
      let certnum = "";
      if (this.userForm.accountType === "Patient") {
        this.userForm.admin = false;
      }
      if (this.userForm.accountType === "Home Health Aid") {
        hvcertificate = this.userForm.hascertificate;
        certnum = this.userForm.certificateValue;
        isaid = this.userForm.accountType;
      }
      if (this.userForm.accountType === "Provider" && !this.userForm.providerType) {
        this.$swal({ type: "warning", title: "Error", text: "Please select a Provider Type before saving." });
        return;
      }
      // Contacts from Add User: enforce patient + contact type
      if (this.needsContactPatientAndType && !this.selectedPatientId) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please select a patient before saving.",
        });
        return;
      }
      if (this.needsContactPatientAndType && !this.selectedRelationTypeId) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please select a contact type before saving.",
        });
        return;
      }
      // Former Add Contact always persisted account_type as Contact (singular).
      if (this.isContactAccountType) {
        this.userForm.accountType = "Contact";
        this.userForm.additionalTopLevelGroupIds = [];
      }
      if (!this.validateUserForm()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      // Ticket 334: re-check NPI uniqueness on keyon (MySQL authority) and abort
      // BEFORE register() runs, so a duplicate never gets written to either store.
      if (
        this.userForm.accountType === "Provider" ||
        this.userForm.accountType === "Administrator"
      ) {
        const npiVal = (this.userForm.npi || "").trim();
        if (npiVal) {
          let npiTaken = false;
          try {
            npiTaken = await this.npiExistsInKeyon(npiVal);
          } catch (e) {
            console.error(e);
          }
          if (npiTaken) {
            this.userFormErrors.npi = [VALIDATION_ERRORS.NPI_EXISTS];
            this.$swal({
              type: "warning",
              title: "Duplicate NPI",
              text: "This NPI is already registered to another user.",
            });
            return;
          }
        }
      }
      // Ticket 334 follow-up: same awaited re-check for no-NPI roles
      // (RN/LPN license+state, Allied license, HHA certificate) before register().
      const roleCtx = this.roleIdentifierContext();
      if (roleCtx) {
        let taken = false;
        try {
          taken = await this.roleIdentifierExistsInKeyon(roleCtx.args);
        } catch (e) {
          console.error(e);
        }
        if (taken) {
          this.userFormErrors[roleCtx.field] = [roleCtx.error];
          this.$swal({
            type: "warning",
            title: "Duplicate",
            text: roleCtx.error,
          });
          return;
        }
      }
      let loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: () => h("div", {}, `Creating account...`),
        }
      );
      this.nwform.cell = this.userForm.primaryPhone;
      this.nwform.accountnumber = this.allData.patient.externId2;
      this.nwform.accountrole = this.userForm.accountType;
      this.nwform.Firstname = this.userForm.first;
      this.nwform.Lastname = this.userForm.last;
      this.nwform.Address = this.userForm.addr;
      this.nwform.prCity = this.userForm.city;
      this.nwform.prState = this.userForm.state;
      this.nwform.prZip = this.userForm.zip;
      this.nwform.accountType = this.userForm.accountType;
      if (this.nwform.accountType == "Home Health Aid") {
        this.nwform.isHHAid = isaid;
        this.nwform.aidHasCertificate = hvcertificate;
        this.nwform.aidCerticateValue = certnum;
      }
      if (this.nwform.accountType === "Allied Professional") {
        this.nwform.specialty = this.userForm.specialty || "";
      }
      if(this.nwform.accountType ==="Provider")
      {
        this.nwform.providerType = this.userForm.providerType ||""
      }
      this.nwform.commpref = this.userForm.pref;
      // Provider/Administrator NPI now lives in userForm.npi (was licenseNum);
      // keep keyon's proffesionalLicense populated by falling back to it.
      this.nwform.license = this.userForm.licenseNum || this.userForm.npi;
      this.nwform.practicestate = this.userForm.licenseSt;
      if (this.isNurseUser) {
        this.nwform.insuranceCompany = this.userForm.insuranceCompany || "";
        this.nwform.insuranceStart = this.userForm.insuranceStart || "";
        this.nwform.insuranceEnd = this.userForm.insuranceEnd || "";
        this.nwform.perIncidentAmnt = this.userForm.perIncidentAmnt || "";
        this.nwform.annualAggAmnt = this.userForm.annualAggAmnt || "";
      }
      this.nwform.dob = this.userForm.dob;
      this.nwform.gender = this.userForm.gender;
      this.nwform.username = this.userForm.login;
      this.nwform.password = this.userForm.password;
      this.nwform.email = this.userForm.email;
      this.nwform.uniqueNineID = this.userForm.externid;
      this.nwform.primary_group_name = this.selectedAccountPrimaryGroup || "";
      if (this.isContactAccountType) {
        // Associate contact with selected patient (from dropdown) or active patient
        if (this.selectedPatientId) {
          this.nwform.primary_group_owner_unique_ID = String(this.selectedPatientId);
        } else if (this.allData?.patient?.externId) {
          this.nwform.primary_group_owner_unique_ID = String(this.allData.patient.externId);
        }
        // Same as former Add Contact: no extra top-level group memberships
        this.nwform.additional_group_ids = "[]";
      } else {
        this.nwform.additional_group_ids = JSON.stringify(this.userForm.additionalTopLevelGroupIds || []);
      }
      // "Require patient verification" is only applicable to brand-new Patient accounts (not Contacts).
      if (this.userForm.accountType === "Patient") {
        // If checked, set to 1, otherwise set to 0
        this.nwform.require_patient_verification = this.userForm.requirePatientVerification
          ? "1"
          : "0";
      } else {
        delete this.nwform.require_patient_verification;
      }
      this.userForm.externid2 = this.nwform.accountnumber;
      // From here until SendAccountInfo has sent them, the uploads belong to
      // this save: nothing the form holds is released under it.
      this.unclaimedCredentialUploads.beginSave();
      register(this.userForm)
        .then((data) => {
          if (data.externid && data.externid != "") {
            this.nwform.id = data.userId != null && data.userId !== "" ? data.userId : data.externid;
            return this.SendAccountInfo();
          }
          alert("Something wrong with register function");
          loader.hide();
          return Promise.reject(new Error("register_missing_externid"));
        })
        .then((createdOk) => {
          loader.hide();
          if (createdOk === true) {
            // If registering from an existing contact record, link registered_unique_id in MySQL patient_contacts
            if (this.lockAccountTypeToContact && this.prefillContact) {
              const contactUuid = this.prefillContact.contact_uuid || this.prefillContact.id;
              if (contactUuid) {
                savePatientContact({
                  id: contactUuid,
                  contact_uuid: contactUuid,
                  accountnumber: this.nwform.accountnumber,
                  patient_unique_id: this.nwform.primary_group_owner_unique_ID,
                  registered_unique_id: String(this.nwform.id || this.nwform.uniqueNineID || ""),
                }).catch((err) => console.warn("Failed to link registered contact ID:", err));
              }
            } else if (this.needsContactPatientAndType) {
              // Add User → Contacts: write patient_contacts with profile fields from this form
              const stateAbbr = String(this.userForm.state || "").trim();
              const stateMatch = (this.allData?.states || []).find(
                (s) => String(s.abbr || "").toUpperCase() === stateAbbr.toUpperCase()
              );
              savePatientContact({
                accountnumber: this.nwform.accountnumber,
                patient_unique_id: this.nwform.primary_group_owner_unique_ID,
                firstName: this.userForm.first,
                lastName: this.userForm.last,
                email: this.userForm.email,
                dob: this.userForm.dob,
                gender: this.userForm.gender,
                relationType: this.selectedRelationTypeId,
                relationName: this.selectedContactRelationName,
                primaryPhone: this.userForm.primaryPhone || "",
                primaryPhoneType: this.userForm.primaryPhoneType || 0,
                address1: this.userForm.addr || "",
                city: this.userForm.city || "",
                state: stateMatch ? stateMatch.id : 0,
                stateAbbr: stateAbbr || (stateMatch?.abbr || ""),
                zip: this.userForm.zip || "",
                registered_unique_id: String(this.nwform.id || this.nwform.uniqueNineID || ""),
              }).catch((err) => console.warn("Failed to create patient_contacts row for new contact:", err));
            }
            this.$swal({
              type: "success",
              title: "Success",
              text: this.postCreateSuccessMessage(),
            });
            this.$emit("close");
          }
        })
        .catch((err) => {
          console.log(err);
          loader.hide();
          const msg = typeof err === "string" ? err : err?.message || "";
          if (msg === "register_missing_externid") {
            return; // already surfaced above
          }
          alert("Caught exception for register function");
        })
        .finally(() => this.unclaimedCredentialUploads.endSave());
    },
    validateName(nameType) {
      const nameRegex = new RegExp("^([a-zA-Z])+([ a-zA-Z])*$");
      let error = null;
      this.userForm[nameType] = this.userForm[nameType].trim();
      this.userFormErrors[nameType] = [];
      if (this.userForm[nameType] !== "" && !nameRegex.test(this.userForm[nameType])) {
        error = VALIDATION_ERRORS.LETTERS_ONLY;
        this.userFormErrors[nameType][this.userFormErrors[nameType].length] = error;
      }
    },
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      let error = null;
      this.userForm.login = this.userForm.login.trim();
      this.userFormErrors.login = [];
      if (!usernameRegex.test(this.userForm.login)) {
        error = VALIDATION_ERRORS.USERNAME_CHARACTERS;
        this.userFormErrors.login[this.userFormErrors.login.length] = error;
      }
      if (this.userForm.login.length < 8 || this.userForm.login.length > 24) {
        error = VALIDATION_ERRORS.USERNAME_LENGTH;
        this.userFormErrors.login[this.userFormErrors.login.length] = error;
      }
      if (this.userFormErrors.login.length < 1) {
        isUserExist(this.userForm.login)
          .then((userExists) => {
            // Assign (don't push) so overlapping isUserExist replies can't stack the same message.
            this.userFormErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
          })
          .catch((err) => {
            alert(err);
          });
      }
      return true;
    },
    validateEmail() {
      this.userForm.email = this.userForm.email.trim();
      this.userFormErrors.email = [];
      if (!this.userForm.email) return;

      // Typical local@domain.tld shape (same pattern as OrderPopup / invite flows).
      if (!this.isValidEmailFormat(this.userForm.email)) {
        this.userFormErrors.email = [VALIDATION_ERRORS.EMAIL_INVALID];
        return;
      }

      isEmailExist(this.userForm.email)
        .then((exists) => {
          this.userFormErrors.email = exists ? [VALIDATION_ERRORS.EMAIL_EXISTS] : [];
        })
        .catch((err) => {
          alert(err);
        });
    },
    isValidEmailFormat(email) {
      return /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(String(email || "").trim());
    },
    // --- Account Access panel (manage_account_credentials) ---
    validateCredentialsUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      const value = (this.credentialsForm.username || "").trim();
      this.credentialsForm.username = value;
      this.credentialsErrors.username = [];
      if (!value || value === (this.workingEditRecord?.username || "")) return;
      if (!usernameRegex.test(value)) {
        this.credentialsErrors.username = [VALIDATION_ERRORS.USERNAME_CHARACTERS];
        return;
      }
      if (value.length < 8 || value.length > 24) {
        this.credentialsErrors.username = [VALIDATION_ERRORS.USERNAME_LENGTH];
        return;
      }
      isUserExist(value)
        .then((exists) => {
          this.credentialsErrors.username = exists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
        })
        .catch((err) => alert(err));
    },
    validateCredentialsEmail() {
      const value = (this.credentialsForm.email || "").trim();
      this.credentialsForm.email = value;
      this.credentialsErrors.email = [];
      if (!value || value === (this.workingEditRecord?.email || "")) return;
      if (!this.isValidEmailFormat(value)) {
        this.credentialsErrors.email = [VALIDATION_ERRORS.EMAIL_INVALID];
        return;
      }
      isEmailExist(value)
        .then((exists) => {
          this.credentialsErrors.email = exists ? [VALIDATION_ERRORS.EMAIL_EXISTS] : [];
        })
        .catch((err) => alert(err));
    },
    validateCredentialsPassword() {
      this.credentialsErrors.newPassword = [];
      this.credentialsErrors.newPassword2 = [];
      const { newPassword, newPassword2 } = this.credentialsForm;
      if (!newPassword && !newPassword2) return;
      this.credentialsErrors.newPassword = getPasswordPolicyErrors(newPassword, [
        this.userForm.first,
        this.userForm.last,
      ]);
      if (newPassword2 && newPassword !== newPassword2) {
        this.credentialsErrors.newPassword2 = [VALIDATION_ERRORS.PASSWORD_MISMATCH];
      }
    },
    /** Collapsing the panel clears any typed-but-unsaved password so it
     * can't tag along on a later, unrelated save (e.g. admin types a
     * password, closes the panel without saving, later reopens it just to
     * fix the email - the old password value shouldn't still be sitting
     * there ready to submit). Username/email are left alone since those
     * are visible, intentional edits either way. */
    toggleCredentialsPanel() {
      this.credentialsPanelOpen = !this.credentialsPanelOpen;
      if (!this.credentialsPanelOpen) {
        this.credentialsForm.newPassword = "";
        this.credentialsForm.newPassword2 = "";
        this.credentialsErrors.newPassword = [];
        this.credentialsErrors.newPassword2 = [];
      }
    },
    /** Posts only the credential fields that actually changed to
     * AdminUpdateAccountCredentials (Postgres LA_user first, then MySQL
     * mirror) - independent save from the profile fields' form submit. */
    async saveAccountAccess() {
      if (!this.credentialsFormIsValid || this.credentialsSaving) return;
      const identity = resolveKeyonPrivilegeIdentity(this.allData);
      const targetUniqueID = this.workingEditRecord?.uniqueID || this.userForm.externid;
      const originalUsername = this.workingEditRecord?.username || "";
      const originalEmail = this.workingEditRecord?.email || "";

      this.credentialsSaving = true;
      this.credentialsResultMessage = "";
      this.credentialsResultIsError = false;
      try {
        const payload = {
          Account: {
            API_Meth: "AdminUpdateAccountCredentials",
            accountnumber: identity.accountnumber,
            actorId: identity.unique_ID,
            targetUniqueID,
            username: this.credentialsForm.username !== originalUsername ? this.credentialsForm.username : "",
            email: this.credentialsForm.email !== originalEmail ? this.credentialsForm.email : "",
            newPassword: this.credentialsInviteMode ? "" : this.credentialsForm.newPassword,
            sendResetInvite: this.credentialsInviteMode,
          },
        };
        const res = await axios.post(CURR_API + "/tswebhook.php", payload, {
          headers: { "Content-Type": "application/json;" },
        });
        const data = res.data || {};
        const status = String(data.status || "");
        const results = data.results || {};
        const failed = Object.entries(results).filter(([, r]) => r.status !== "200");
        if (status.startsWith("403") || status.startsWith("404") || status.startsWith("400")) {
          // Whole-request failure (no permission, no Postgres login record for
          // this person yet, or nothing to update) - no per-field results to
          // list, just the backend's explanation.
          this.credentialsResultIsError = true;
          this.credentialsResultMessage = data.message || "Could not update account access.";
        } else if (failed.length) {
          this.credentialsResultIsError = true;
          this.credentialsResultMessage = failed.map(([field, r]) => `${field}: ${r.message}`).join(" | ");
        } else {
          this.credentialsResultIsError = false;
          // Postgres/MySQL email drift note (if any) rides along on data.message.
          this.credentialsResultMessage = data.message || "Account access updated.";
          if (this.workingEditRecord) {
            if (payload.Account.username) this.workingEditRecord.username = payload.Account.username;
            if (payload.Account.email) this.workingEditRecord.email = payload.Account.email;
          }
          this.credentialsForm.newPassword = "";
          this.credentialsForm.newPassword2 = "";
        }
      } catch (err) {
        this.credentialsResultIsError = true;
        this.credentialsResultMessage = "Could not reach the server. Please try again.";
      } finally {
        this.credentialsSaving = false;
      }
    },
    // Ticket 334: NPI uniqueness is checked on the MySQL/keyon side
    // (providers.npinumber), not pacmny-be/Postgres.
    async npiExistsInKeyon(npi) {
      const value = String(npi || "").trim();
      if (!value) return false;
      const payload = { Account: { API_Meth: "IsNpiExist", npi: value } };
      const res = await axios.post(CURR_API + "/tswebhook.php", payload, {
        headers: { "Content-Type": "application/json;" },
      });
      return !!(res && res.data && res.data.isNpiExist);
    },
    validateNpi() {
      // Global NPI uniqueness for Provider/Administrator. No-NPI roles dedupe by
      // state license (ticket 334 follow-up), so only check when a value is entered.
      this.userForm.npi = (this.userForm.npi || "").trim();
      this.userFormErrors.npi = [];
      if (this.userForm.npi === "") {
        return;
      }
      const seq = ++this.npiValidationSeq;
      this.npiExistsInKeyon(this.userForm.npi)
        .then((npiExists) => {
          if (seq !== this.npiValidationSeq) return;
          this.userFormErrors.npi = npiExists ? [VALIDATION_ERRORS.NPI_EXISTS] : [];
        })
        .catch((err) => {
          if (seq !== this.npiValidationSeq) return;
          this.userFormErrors.npi = [];
          console.error(err);
        });
    },
    // Ticket 334 follow-up: per-account uniqueness for no-NPI roles, checked on
    // the MySQL/keyon side. RN/LPN -> (license, state); Allied -> license;
    // HHA -> certificate.
    async roleIdentifierExistsInKeyon({ accountType, license, licenseState, certificate }) {
      const payload = {
        Account: {
          API_Meth: "IsRoleIdentifierExist",
          accountnumber: this.allData?.patient?.externId2 || "",
          accountType: accountType || "",
          license: String(license || "").trim(),
          licenseState: String(licenseState || "").trim(),
          certificate: String(certificate || "").trim(),
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", payload, {
        headers: { "Content-Type": "application/json;" },
      });
      return !!(res && res.data && res.data.exists);
    },
    // Resolve which field/error and identifier apply to the current role, or null.
    roleIdentifierContext() {
      const t = this.userForm.accountType;
      if (t === "Registered Nurse" || t === "Licensed Practical Nurse") {
        const license = (this.userForm.licenseNum || "").trim();
        const licenseState = (this.userForm.licenseSt || "").trim();
        // Need both halves to form the (license, state) key.
        if (!license || !licenseState) return null;
        return { field: "licenseNum", error: VALIDATION_ERRORS.LICENSE_EXISTS, args: { accountType: t, license, licenseState } };
      }
      if (t === "Allied Professional") {
        const license = (this.userForm.licenseNum || "").trim();
        if (!license) return null;
        return { field: "licenseNum", error: VALIDATION_ERRORS.LICENSE_EXISTS, args: { accountType: t, license } };
      }
      if (t === "Home Health Aid") {
        const certificate = (this.userForm.certificateValue || "").trim();
        if (!certificate) return null;
        return { field: "certificateValue", error: VALIDATION_ERRORS.CERTIFICATE_EXISTS, args: { accountType: t, certificate } };
      }
      return null;
    },
    validateRoleIdentifier() {
      // Clear stale errors on the role-identifier fields, then re-check.
      this.userFormErrors.licenseNum = [];
      this.userFormErrors.certificateValue = [];
      const ctx = this.roleIdentifierContext();
      if (!ctx) return;
      const seq = ++this.roleIdValidationSeq;
      this.roleIdentifierExistsInKeyon(ctx.args)
        .then((exists) => {
          if (seq !== this.roleIdValidationSeq) return;
          this.userFormErrors[ctx.field] = exists ? [ctx.error] : [];
        })
        .catch((err) => {
          if (seq !== this.roleIdValidationSeq) return;
          this.userFormErrors[ctx.field] = [];
          console.error(err);
        });
    },
    validateUserForm() {
      // Catch invalid format on submit even if the user never re-triggered keyup.
      const email = (this.userForm.email || "").trim();
      if (email && !this.isValidEmailFormat(email)) {
        this.userFormErrors.email = [VALIDATION_ERRORS.EMAIL_INVALID];
      }
      for (let key in this.userFormErrors) {
        if (this.userFormErrors[key] && this.userFormErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    /**
     * Identifies a brand-new Patient account where the admin unchecked "Require patient verification".
     * Contact accounts and clinical/staff roles do not use patient verification.
     */
    isPatientWithoutVerification() {
      return (
        this.userForm.accountType === "Patient" &&
        !this.userForm.requirePatientVerification
      );
    },
    shouldSendSubAccountVerificationEmail() {
      return this.userForm.accountType && !this.isPatientWithoutVerification();
    },
    postCreateSuccessMessage() {
      if (this.isContactAccountType) {
        return "This contact account has been created and a registration link has been sent to their e-mail. Once verified, they will be assigned to the selected patient.";
      }
      if (this.isPatientWithoutVerification()) {
        return "This patient account has been created and is active.";
      }
      if (this.showsCaregiverPatientAssignment && (this.assignedPatientIds || []).length > 0) {
        return "This account has been created. Patient assignments are pending until they verify their e-mail.";
      }
      return "This account has been created. It must now be verified before it can be used.";
    },
    /** Subaccount id from registration + CreateSubAccount prep (nwform.id). */
    createdSubaccountUniqueId() {
      return String(
        this.nwform.id != null && this.nwform.id !== ""
          ? this.nwform.id
          : this.userForm.externid || ""
      ).trim();
    },
    emitLockedRolePostCreate() {
      const id = this.createdSubaccountUniqueId();
      if (!id) {
        return;
      }
      if (this.lockAccountTypeToProvider) {
        this.$emit("provider-account-created", { provider_unique_ID: id });
      } else if (this.lockToNurseRoleTypes) {
        this.$emit("nurse-account-created", { nurse_unique_ID: id });
      }
    },
    async SendAccountInfo() {
      const formdata = new FormData();
      formdata.append("API_Meth", "CreateSubAccount");
      Object.keys(this.nwform).forEach((key) => {
        const val = this.nwform[key];
        // appendCredentialSlots below is the one writer of the credential slots.
        if (key === "license_file_uid" || key === "insurance_file_uid") {
          return;
        }
        // Skip File objects here; append live inputs below so PHP $_FILES is set.
        if (typeof File !== "undefined" && val instanceof File) {
          return;
        }
        if (val != null && typeof val === "object") {
          return;
        }
        formdata.append(key, val == null ? "" : val);
      });
      // Per slot: the uid from the immediate upload, or the picked file, never
      // both (keyon refuses a slot carrying both).
      const licenseInput = document.getElementById("licensePdf");
      const insuranceInput = document.getElementById("insurancePdf");
      appendCredentialSlots(formdata, {
        licenseUid: this.nwform.license_file_uid,
        insuranceUid: this.nwform.insurance_file_uid,
        licenseFile: licenseInput?.files?.[0],
        insuranceFile: insuranceInput?.files?.[0],
      });
      // Deferred caregiver↔patient panel links (pending_group_assignments until verify).
      if (this.showsCaregiverPatientAssignment) {
        formdata.append(
          "pending_patient_unique_IDs",
          JSON.stringify((this.assignedPatientIds || []).map(String).filter((x) => x.length > 0))
        );
        const assignedBy = String(
          this.allData?.manager?.externId || this.allData?.patient?.externId || ""
        ).trim();
        if (assignedBy) {
          formdata.append("assigned_by_unique_ID", assignedBy);
        }
      }
      this.unclaimedCredentialUploads.beginSave();
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", formdata);
        if (res.data.message == "Account Created Successfully") {
          // The new account row references the uploaded files it was sent.
          this.unclaimedCredentialUploads.saved(sentCredentialUids(formdata));
          this.emitLockedRolePostCreate();
          if (this.shouldSendSubAccountVerificationEmail()) {
            await this.SendSubAccountEmail();
          }
          return true;
        }
        // Ticket 334: keyon's server-side NPI guard winning a race with the
        // pre-register check — surface it on the NPI field.
        if (res.data.message == "NPI Already Registered") {
          this.userFormErrors.npi = [VALIDATION_ERRORS.NPI_EXISTS];
          this.$swal({
            type: "warning",
            title: "Duplicate NPI",
            text: res.data.error || "This NPI is already registered to another user.",
          });
          return false;
        }
        // Ticket 334 follow-up: per-account license/certificate duplicate guards.
        if (res.data.message == "License Already Registered") {
          this.userFormErrors.licenseNum = [VALIDATION_ERRORS.LICENSE_EXISTS];
          this.$swal({
            type: "warning",
            title: "Duplicate License",
            text: res.data.error || VALIDATION_ERRORS.LICENSE_EXISTS,
          });
          return false;
        }
        if (res.data.message == "Certificate Already Registered") {
          this.userFormErrors.certificateValue = [VALIDATION_ERRORS.CERTIFICATE_EXISTS];
          this.$swal({
            type: "warning",
            title: "Duplicate Certificate",
            text: res.data.error || VALIDATION_ERRORS.CERTIFICATE_EXISTS,
          });
          return false;
        }
        if (res.data.message == "License Already Assigned") {
          alert(res.data.error);
        } else {
          alert(refusalMessage(res.data) || "Account Not Created Successfully");
        }
        return false;
      } catch (err) {
        console.log(err);
        alert(refusalMessage(err?.response?.data) || ("Error " + (err?.response?.data?.error || err?.message || err)));
        return false;
      } finally {
        this.unclaimedCredentialUploads.endSave();
      }
    },
    /** Re-fetches this same person from SearchAccountForEdit (matched by email,
     * which is immutable in edit mode) and repopulates the form with the
     * server's authoritative current values. Called right after a successful
     * save so the admin sees their edits reflected immediately, instead of
     * having to close/re-search/reload to confirm the save actually held. */
    async refreshWorkingEditRecord() {
      const prior = this.workingEditRecord;
      if (!prior || !prior.email) return null;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            AccountUser: {
              API_Meth: "SearchAccountForEdit",
              accountnumber: this.allData.patient.externId2,
              searchTerm: prior.email,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        const records = Array.isArray(res?.data?.records) ? res.data.records : [];
        const match =
          records.find((x) => prior.uniqueID && x.uniqueID === prior.uniqueID) ||
          records.find((x) => x.email === prior.email) ||
          null;
        if (match) {
          this.workingEditRecord = match;
          this.applyEditPrefill();
        }
        return match;
      } catch (e) {
        console.error("Failed to refresh this account's current values:", e);
        return null;
      }
    },
    /** Edit Users submit: routes to either the (a3) update-in-place path or the
     * (a2) promote-to-new-role path depending on whether this person already
     * has a Provider/Nurse/Patient record. */
    async submitEditAccount() {
      if (this.credentialUploadStillRunning()) {
        return;
      }
      if (!this.userForm.first || !this.userForm.last) {
        this.$swal({ type: "warning", title: "Error", text: "First and last name are required." });
        return;
      }
      if (!this.editAccountTypeLocked && !this.userForm.accountType) {
        this.$swal({ type: "warning", title: "Error", text: "Please select an account type." });
        return;
      }
      if (this.userForm.accountType === "Provider" && !this.userForm.providerType) {
        this.$swal({ type: "warning", title: "Error", text: "Please select a Provider Type before saving." });
        return;
      }
      let loader = this.$loading.show(
        { container: this.$refs.pageBody },
        { after: () => h("div", {}, `Saving changes...`) }
      );
      const accountnumber = this.allData.patient.externId2;
      const r = this.workingEditRecord || {};
      const au = r.account_user || {};
      // An edit save does not call saved(): not every path sends every slot
      // (a promotion sends only an aide's insurance), so the form keeps holding
      // its uploads and releases them on close. keyon refuses to release the
      // ones a save claimed. Nothing is released while it runs.
      this.unclaimedCredentialUploads.beginSave();
      try {
        const updateAccountUserRes = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            AccountUser: {
              API_Meth: "UpdateAccountUser",
              accountnumber,
              uniqueID: r.uniqueID,
              accountType: this.userForm.accountType,
              firstname: this.userForm.first,
              lastname: this.userForm.last,
              phone: this.userForm.primaryPhone || "",
              address: this.userForm.addr || "",
              city: this.userForm.city || "",
              state: this.userForm.state || "",
              zip: this.userForm.zip || "",
              proffesionalLicense: this.userForm.licenseNum || this.userForm.npi || "",
              emrLicenseNumber: au.emr_licensenumber || "",
              communicationPreference: this.userForm.pref || "Email",
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (!updateAccountUserRes?.data || updateAccountUserRes.data.status !== "Successfull") {
          throw new Error(updateAccountUserRes?.data?.message || "Failed to update account");
        }

        // This person is also the org owner (has a real `accounts` row) - keep
        // the org-level record's name/username/address/phone in sync too.
        if ((r.foundIn || []).includes("accounts") && r.accounts) {
          await axios.post(
            CURR_API + "/tswebhook.php",
            {
              AccountUser: {
                API_Meth: "UpdateAccountInfo",
                accountnumber,
                firstname: this.userForm.first,
                lastname: this.userForm.last,
                username: this.userForm.login || "",
                address: this.userForm.addr || "",
                city: this.userForm.city || "",
                state: this.userForm.state || "",
                zip: this.userForm.zip || "",
                phone: this.userForm.primaryPhone || "",
              },
            },
            { headers: { "Content-Type": "application/json;" } }
          );
        }

        if (this.editHasRoleRecord) {
          await this.submitEditTypeSpecificUpdate(accountnumber);
        } else {
          await this.submitEditPromote(accountnumber);
        }

        // Re-fetch this same person from the server and repopulate the form
        // with the authoritative current values, right here, without closing.
        // That's what actually proves the save held - no reload/re-search needed.
        const refreshed = await this.refreshWorkingEditRecord();
        loader.hide();
        if (refreshed) {
          this.$emit("saved", refreshed);
        }
        this.lastSavedAt = new Date();
        this.$swal({ type: "success", title: "Saved", text: "This account has been updated." });
      } catch (err) {
        loader.hide();
        console.error(err);
        this.$swal({
          type: "error",
          title: "Error",
          text: err?.response?.data?.message || err?.message || "Something went wrong updating this account.",
        });
      } finally {
        this.unclaimedCredentialUploads.endSave();
      }
    },
    /** (a3) Person already has a Provider/Nurse/Patient row - update it in place.
     * Routed by which table SearchAccountForEdit actually found them in, not by
     * accountType text, since Allied Professional can land in either providers
     * or nurses depending on specialty mapping. */
    async submitEditTypeSpecificUpdate(accountnumber) {
      const r = this.workingEditRecord;
      const foundIn = r.foundIn || [];
      if (foundIn.includes("providers")) {
        const p = r.providers || {};
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Provider: {
              API_Meth: "UpdateProvider",
              providerid: p.providerid,
              email: this.userForm.email,
              patientid: p.patientid || "0099",
              ordernumber: p.ordernumber || "0099",
              firstname: this.userForm.first,
              lastname: this.userForm.last,
              address1: this.userForm.addr || "",
              address2: p.addr2 || "",
              city: this.userForm.city || "",
              state: this.userForm.state || "",
              zip: this.userForm.zip || "",
              phone: this.userForm.primaryPhone || "",
              fax: p.fax || "",
              npinumber: this.userForm.npi || "",
              status: p.status || "Active",
              cell: this.userForm.primaryPhone || "",
              providerType: this.userForm.providerType || "",
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (!res?.data || res.data.msg !== "Updated") {
          throw new Error(res?.data?.error || "Failed to update the provider record");
        }
      } else if (foundIn.includes("nurses")) {
        const n = r.nurses || {};
        const isHHA = String(n.caregivetype || "").toLowerCase() === "home health aid";
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            ManageNurseList: {
              API_Meth: "InternalUpdateNurse",
              // Identify by the person's own stable ID rather than
              // licensnum/certificatenumber, which have no uniqueness
              // constraint and can misidentify the wrong nurse when shared/blank.
              providerid: r.uniqueID,
              ncsid: n.ncsbnid || "",
              jurisdiction: "",
              subactioncode: "",
              // userForm.licenseNum is editable (bound to this same field for
              // both RN/LPN and HHA); n.certificatenumber stays as the HHA
              // fallback only when the form field itself is empty.
              licensnum: this.userForm.licenseNum || n.certificatenumber || "",
              licenseType: n.licensetype || "",
              email: this.userForm.email,
              primephone: this.userForm.primaryPhone || "",
              secondaryphone: n.secondaryphone || "",
              address1: this.userForm.addr || "",
              address2: n.addr2 || "",
              city: this.userForm.city || "",
              state: this.userForm.state || "",
              zip: this.userForm.zip || "",
              lastfourssn: n.socialnum || "",
              // Was resending the original fetched value (n.dob) regardless of
              // what the admin edited in the form - DOB edits silently never
              // persisted for Nurse/HHA/Allied-mapped-to-nurses records.
              bdayear: this.userForm.dob || "",
              hospitalpracsetting: n.hospsetting || "",
              hostpracsettingother: n.hospsettingother || "",
              notficationenabled: n.notficationEnabled || "",
              reminderenabled: n.reminderEnabled || "",
              locationlist: n.locationlist || "",
              recid: "",
              accountnumber,
              firstname: this.userForm.first,
              lastname: this.userForm.last,
              activestatus: n.activestatus || "Active",
              checkstatus: n.checkstatus || "",
              // Same stale-value bug as dob/perIncidentAmnt - these are
              // editable fields, so they must send the current form value.
              insuranceCompany: this.userForm.insuranceCompany || "",
              insuranceStartDt: this.userForm.insuranceStart || "",
              insuranceEndDate: this.userForm.insuranceEnd || "",
              nurseType: n.caregivetype || this.userForm.accountType,
              // Same stale-value bug as dob (bdayear) had - these are
              // editable fields, so they must send the current form value,
              // not the original fetched one, or edits silently never save.
              perIncdedentAmount: this.userForm.perIncidentAmnt || "",
              annualAggAmount: this.userForm.annualAggAmnt || "",
              action: isHHA ? "Update HHA" : "",
              // A uid key only for a file uploaded during this edit: absent keys
              // leave the stored references untouched (plan 7.8).
              ...changedUidKeys({
                licenseUid: this.nwform.license_file_uid,
                insuranceUid: this.nwform.insurance_file_uid,
              }),
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (!res?.data || res.data.message !== "Updated") {
          throw new Error(res?.data?.error || "Failed to update the nurse record");
        }
      } else if (foundIn.includes("patients")) {
        const p = r.patients || {};
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            UpdatePatientData: {
              API_Meth: "Upate_Patients",
              accountnumber,
              patientid: p.mid || "",
              personalID: r.uniqueID,
              firstname: this.userForm.first,
              lastname: this.userForm.last,
              gender: this.userForm.gender || "",
              address: this.userForm.addr || "",
              city: this.userForm.city || "",
              state: this.userForm.state || "",
              zip: this.userForm.zip || "",
              emergencycontact: p.emergency_contactname || "",
              maritalstatus: p.matial_status || "",
              dob: this.userForm.dob || null,
              ssnumber: p.socnum || "",
              phone: this.userForm.primaryPhone || "",
              email: this.userForm.email,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (!res?.data || res.data.message !== "Updated") {
          throw new Error(res?.data?.error || res?.data?.errormsg || "Failed to update the patient record");
        }
      }
    },
    /** (a2) Person was found only in accounts/account_user - the admin picked a
     * brand-new role for them. Reuses CreateSubAccount (same as the normal
     * create flow) with accountUserRowExists so the backend updates the
     * existing account_user row in place instead of inserting a new one. */
    async submitEditPromote(accountnumber) {
      const r = this.workingEditRecord;
      const au = r.account_user;
      const accountUserRowExists = !!au;
      const formdata = new FormData();
      formdata.append("API_Meth", "CreateSubAccount");
      formdata.append("accountnumber", accountnumber);
      formdata.append(
        "uniqueNineID",
        r.uniqueID || String(Math.floor(Math.random() * 899999999) + 100000000)
      );
      formdata.append("accountType", this.userForm.accountType);
      formdata.append("accountrole", this.userForm.accountType);
      formdata.append("accountUserRowExists", accountUserRowExists ? "true" : "false");
      formdata.append("existingEmrLicense", au?.emr_licensenumber || "");
      formdata.append(
        "username",
        au?.username || this.userForm.login || (this.userForm.first + this.userForm.last).toLowerCase()
      );
      formdata.append("Firstname", this.userForm.first);
      formdata.append("Lastname", this.userForm.last);
      formdata.append("Address", this.userForm.addr || "");
      formdata.append("prCity", this.userForm.city || "");
      formdata.append("prState", this.userForm.state || "");
      formdata.append("prZip", this.userForm.zip || "");
      formdata.append("email", this.userForm.email);
      formdata.append("specialty", this.userForm.specialty || "");
      formdata.append("cell", this.userForm.primaryPhone || "");
      formdata.append("license", this.userForm.licenseNum || this.userForm.npi || "");
      // Omit rather than send "" — an empty string into a DATE column is a
      // strict-mode error, while an absent key leaves the column NULL.
      if (this.userForm.dob) formdata.append("dob", this.userForm.dob);
      formdata.append("gender", this.userForm.gender || "");
      formdata.append("commpref", this.userForm.pref || "Email");
      if (this.userForm.accountType === "Home Health Aid") {
        formdata.append("aidHasCertificate", this.userForm.hascertificate || "");
        formdata.append("aidCerticateValue", this.userForm.certificateValue || "");
        // The insurance uploaded during this edit, else the one already on the
        // account user; keyon accepts that re-use even when the file is missing
        // from storage (plan 7.2 rule b).
        const insuranceUid = promoteInsuranceUid(this.nwform.insurance_file_uid, au);
        if (insuranceUid) formdata.append("insurance_file_uid", insuranceUid);
      }
      if (this.userForm.accountType === "Provider") {
        formdata.append("providerType", this.userForm.providerType || "");
      }
      formdata.append("accntStatus", "Active");
      formdata.append("primary_group_name", this.selectedAccountPrimaryGroup || "");
      formdata.append("additional_group_ids", JSON.stringify(this.userForm.additionalTopLevelGroupIds || []));

      const res = await axios.post(CURR_API + "/tswebhook.php", formdata);
      if (res.data.message !== "Account Created Successfully") {
        throw new Error(res.data.error || res.data.message || "Failed to add the new role");
      }
      // Only a genuine "add a new account type" needs the dual-role congrats
      // email - "Edit Account Details" re-submits the same type and shouldn't
      // announce a role that was never added.
      if (!this.editKeepCurrentType) {
        await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "SendDualRoleEmail",
              accountnumber,
              usertoemail: this.userForm.email,
              firstname: this.userForm.first,
              lastname: this.userForm.last,
              accounttype: this.userForm.accountType,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
      }
    },
    async SendSubAccountEmail() {
      let mcontent = {
        Account: {
          API_Meth: "SendNewSubAccountEmail",
          accountnumber: this.allData.patient.externId2,
          uniquenine: this.nwform.uniqueNineID,
          accounttype: this.userForm.accountType,
          accountholder: this.userForm.first + " " + this.userForm.last,
          usertoemail: this.userForm.email,
          firstname: this.userForm.first,
          lastname: this.userForm.last,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", mcontent, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(() => {})
        .catch((err) => {
          alert(err);
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.add-user-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.add-user-form-header h2 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #0c8687;
}

.caregiver-assign-hint {
  margin: 0 0 0.85rem;
  font-size: 0.85rem;
  color: #6c757d;
  line-height: 1.35;
}

.caregiver-assign-search {
  position: relative;
  margin-bottom: 0.75rem;
}

.caregiver-assign-search .glyphicon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 0.85rem;
}

.caregiver-assign-search .form-control {
  padding-left: 2.1rem;
}

.caregiver-assign-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.caregiver-assign-panel {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.caregiver-assign-panel--assigned {
  border-color: #ced4da;
}

.caregiver-assign-panel-label {
  padding: 0.45rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #495057;
  background: #f1f3f5;
  border-bottom: 1px solid #dee2e6;
}

.caregiver-assign-list {
  list-style: none;
  margin: 0;
  padding: 0.35rem;
  overflow-y: auto;
  max-height: 220px;
  flex: 1;
}

.caregiver-assign-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.5rem;
  border-radius: 6px;
}

.caregiver-assign-item + .caregiver-assign-item {
  border-top: 1px solid #eee;
}

.caregiver-assign-item-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.caregiver-assign-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.caregiver-assign-dob {
  font-size: 0.75rem;
  color: #6c757d;
}

.caregiver-assign-empty {
  padding: 1.25rem 0.75rem;
  text-align: center;
  color: #adb5bd;
  font-size: 0.85rem;
}

@media (max-width: 767px) {
  .caregiver-assign-panels {
    grid-template-columns: 1fr;
  }
}

.new-acc-modal {
  position: fixed;
  top: 0;
  left: 0;
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Safety net for very short viewports; the form's max-height keeps it
     smaller than this box, so it stays centered without clipping. */
  overflow-y: auto;
  padding: 24px 12px;
}

.form-error-summary {
  margin: 0.75rem 0 1.5rem;
  padding: 0.9rem 1.15rem;
  background: #fdecea;
  border: 1px solid #f3b4b0;
  border-radius: 6px;
}

.form-error-summary ul {
  margin: 0;
  padding-left: 1.1rem;
  color: #9b2c2c;
}

.form-error-summary li {
  margin: 0.15rem 0;
}

.allied-prof-first-row {
  display: flex;
  flex-wrap: wrap;
}

.npi-results .npi-result-item {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.npi-lookup-collapse-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  padding: 0.55rem 0.85rem;
  border: 1px solid #0c8687;
  border-radius: 0.375rem;
  background: #fff;
  color: #0c8687;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.npi-lookup-collapse-toggle:hover {
  background: #e8f6f6;
  border-color: #086667;
  color: #086667;
}

.npi-lookup-collapse-toggle:focus-visible {
  outline: 2px solid #0c8687;
  outline-offset: 2px;
}

.npi-lookup-optional-note {
  font-weight: 400;
  color: #6c757d;
}

.npi-lookup-arrow {
  display: inline-block;
  flex-shrink: 0;
  width: 1rem;
  text-align: center;
  transition: transform 0.15s ease;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1;
  color: #0c8687;
}

.npi-lookup-collapse-toggle:hover .npi-lookup-arrow {
  color: #086667;
}

.npi-lookup-arrow.is-open {
  transform: rotate(90deg);
}

.allied-prof-first-row > [class*="col-"] {
  flex: 1 1 0;
  min-width: 0;
}

@media (min-width: 768px) {
  /* Allied specialty row is three equal columns. */
  .allied-prof-first-row > [class*="col-"] {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}

/* Contacts row: Account Type | Patient | Contact Type | compact ID on one line. */
.contact-patient-first-row > [class*="col-"] {
  min-width: 0;
}

@media (min-width: 768px) {
  .contact-patient-first-row {
    flex-wrap: nowrap;
  }
  .contact-patient-first-row > [class*="col-"] {
    flex: 1 1 0;
    max-width: none;
    width: auto;
  }
  /* Keep ID compact on the first line. */
  .contact-patient-first-row > .contact-id-col {
    flex: 0 0 7.5rem;
    max-width: 7.5rem;
    width: 7.5rem;
  }
}

.new-acc-modal form {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  padding: 20px;
  max-width: 50%;
  width: 100%;
  /* Same size as before: capped at 90% of viewport with internal scroll.
     Capping below the overlay height keeps align-items:center from clipping. */
  max-height: 90vh;
  overflow-y: auto;
}

.accountform-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.last-saved-indicator {
  color: #1a7f37;
  font-size: 0.85rem;
  font-weight: 600;
}

.npi-container {
  display: none;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.npi-license {
  margin-bottom: 10px;
}

.npi-license label {
  margin-right: 10px;
}

.npi-license input {
  padding: 5px;
}

@media only screen and (max-width: 576px) {
  .new-acc-modal {
    padding: 12px 8px;
  }
  .new-acc-modal form {
    max-width: unset;
  }
}

/* Account Access panel (manage_account_credentials) */
.account-access-section {
  margin-top: 0.5rem;
}

.account-access-divider {
  border: none;
  border-top: 1px solid #dcdfe3;
  margin: 1rem 0 0.75rem;
}

.account-access-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: none;
  padding: 0.25rem 0;
  color: #0c8687;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
}

.account-access-toggle:hover {
  text-decoration: underline;
}

.account-access-panel {
  margin-top: 0.75rem;
  padding: 1rem;
  background: #f8f9fb;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
}

.account-access-hint {
  font-size: 0.85rem;
  color: #5c636a;
  margin-bottom: 0.9rem;
}

.account-access-warning {
  font-size: 0.85rem;
  color: #8a6100;
  background: #fff6e5;
  border: 1px solid #f0dca6;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.9rem;
}

.account-access-password-mode {
  margin-bottom: 0.9rem;
  font-size: 0.9rem;
}

.account-access-invite-preview {
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 0.75rem;
}

.account-access-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.account-access-result {
  font-size: 0.85rem;
}

.show-password-toggle {
  background: none;
  border: none;
  padding: 0;
  color: #0c8687;
  font-size: 0.85rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}

.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  overflow: hidden;
}

.slide-panel-enter-from,
.slide-panel-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-panel-enter-to,
.slide-panel-leave-from {
  max-height: 640px;
  opacity: 1;
}

@media (max-width: 576px) {
  .account-access-panel {
    padding: 0.75rem;
  }

  .account-access-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
